window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}

(() => {
    const style = document.createElement('style');
    style.id = 'bss-custom-style';
    style.textContent = `
        .card-information .price, .product__info-container .product__info-padded-main .price, .predictive-search__list-item .price, .product-option--price, .cart-item__price-wrapper {
            visibility: hidden;
        }

        [bss-b2b-product-id] > span, [bss-b2b-item-original-price] > span, [bss-b2b-final-line-price] > span, [bss-b2b-cart-total-price] > span {
            font-size: inherit !important;
            color: inherit !important;
        }

        .complementary-products [bss-b2b-product-id] > span {
            font-size: calc(var(--font-heading-scale) * 1.4rem) !important;
        }
    `;
    document.head.appendChild(style);

    const cartEl = document.querySelector('.drawer');
    if (cartEl) {
        const observer = new MutationObserver(mutations => {
            for (mutation of mutations) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    cartEl.classList.contains('active')
                ) {
                    if (!cartEl.querySelector('[bss-b2b-cart-item-key]')) {
                        document.dispatchEvent(new Event("bss_b2b:CustomCartUpdate"));
                    }
                    setTimeout(() => {
                        if (cartEl.querySelector('.complementary-products .mini-card-list li') && !cartEl.querySelector('.complementary-products [bss-b2b-product-id]')) {
                            window.dispatchEvent(new Event('scroll'));
                        }
                    }, 1000);
                    observer.disconnect();
                    return;
                }
            }
        });
        observer.observe(cartEl, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('bss_b2b:loadedObserver', () => {
        if (BSS_B2B.page.isCartPage()) {
            window.dispatchEvent(new Event('scroll'));
        }
    });

    window.addEventListener('DOMContentLoaded', () => {
        if (BSS_B2B?.shopData) {
            document.querySelectorAll('.additional-checkout-buttons').forEach(el => el.remove());
            const searchEl = document.querySelector('.template-search .product-grid-container');
            if (searchEl) searchEl.classList.add('bss-b2b-search-bar');
        } else {
            document.getElementById('bss-custom-style')?.remove();
        }
    });

})();


// Start automatically generated code by KC Solutions

/*────────────────────────────────────╮
│ Auto Install                        │
│ ** User: vuongvv@bsscommerce.com ** │
│ ** Created at : 15/01/2026 10:52 ** │
│ ** Updated at : 15/01/2026 16:59 ** │
╰────────────────────────────────────*/

(() => {
    window.KC = window.KC || {};
    window.KC.coreDataSelector = {"Wpbingo":{selector:{
    collection: {
        selectorCard: ".product-card",
        selectorPrice: ".product-group-price",
        selectorQuickviewBtn: ".product-card__quickview",
    },
    product: {
        selectorForm: ".product-single__metas",
        selectorPrice: '.price-container',
    },
    miniCart: {
        selectorCard: ".ajaxcart__product",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".ajaxcart__price",
        selectorSubtotalPrice: ".ajaxcart__subtotal",
    },
    cart: {
        selectorCard: ".item-cart",
        selectorOriginPrice: ".cart-product-info__price",
        selectorFinalLinePrice: ".cart-table__price",
        selectorSubtotalPrice: ".cart-total__subtotal-price",
    },
    quickView: {
        selectorCard: ".product-quickview",
        selectorPrice: ".js-qv-product-price" 
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'beforeBegin',
            selector: '#checkout'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '#checkout'
        }
    },
    taxExempt: {
       miniCart: {
            position: 'beforeBegin',
            selector: '#checkout'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '#checkout'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '#checkout'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '#checkout'
        }
    }
},coreJS: () => {const isCart = window.location.pathname === '/cart';
if (isCart) {
    handleCartPage();
}
const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    handlePDP();
}
function handleCartPage() {
    setTimeout(() => {
        BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartUpdate', 'CartMutate');
    }, 1000)
    setTimeout(() => {
        BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartUpdate', 'CartMutate');
    }, 3000)
}
function handlePDP() {
    const _pushState = history.pushState;
    const _replaceState = history.replaceState;
    function triggerUrlChange() {
        const event = new Event('urlchange');
        window.dispatchEvent(event);
    }
    history.pushState = function (...args) {
        _pushState.apply(this, args);
        triggerUrlChange();
    };
    history.replaceState = function (...args) {
        _replaceState.apply(this, args);
        triggerUrlChange();
    };
    window.addEventListener('popstate', triggerUrlChange);
    window.addEventListener('urlchange', () => {
        const productForm = document.querySelector('[bss-b2b-product-form="main"]');
        BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', { productForm })
    });
}

document.addEventListener("DOMContentLoaded", e => {
    const targetBody = document.body;
    window.observeMutations(targetBody, { attributeFilter: ['class'] },
        (mutation) => {
            if (mutation.target.className.includes("drawer--open")) {
                BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartUpdate', 'CartMutate');
            }
        })
})

const debouncedCartUpdate = window.kc.debounce(() => {
    BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartUpdate', 'CartMutate');
}, 100);

document.addEventListener("bss_b2b:CustomCartUpdate", e => {
    const targetCartSlider = document.querySelector(".ajaxcart-container");
    window.observeMutations(targetCartSlider, { childList: true, subtree: true },
        (mutation) => {
            debouncedCartUpdate();
        }, true)
});const style = document.createElement("style"); style.innerHTML = `.abc {
  display: none ;
}`;document.head.appendChild(style);},},"Vinova Mate":{selector:{
    collection: {
        selectorCard: "",
        selectorPrice: "",
        selectorQuickviewBtn: ""
    },
    product: {
        selectorForm: ".product-single__information",
        selectorPrice: '.product-price__price',
    },
    miniCart: {
        selectorCard: ".ajaxcart__product",
        selectorOriginPrice: ".product-price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".subtotal span:last-child",
    },
    cart: {
        selectorCard: "",
        selectorOriginPrice: "",
        selectorFinalLinePrice: "",
        selectorSubtotalPrice: ""
    },
    quickView: {
        selectorCard: "",
        selectorPrice: ""
    }
},},"Dawn":{selector:{
    collection: {
        selectorCard: ".collection ul li",
        selectorPrice: ".price__container",
        selectorQuickviewBtn: ":not(*)",
        selectorSearchBar: ":not(*)",
    },
    product: {
        selectorForm: ".product__info-container",
        selectorPrice: ".price__container",
    },
    miniCart: {
        selectorCard: ":not(*)",
        selectorOriginPrice: ":not(*)",
        selectorFinalLinePrice: ":not(*)",
        selectorSubtotalPrice: ":not(*)",
    },
    cart: {
        selectorCard: "cart-items .cart-item",
        selectorOriginPrice: ".cart-item__details > div.product-option",
        selectorFinalLinePrice: ".price",
        selectorSubtotalPrice: ".totals__subtotal-value",
    },
    quickView: {
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    },
    searchBar: { 
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '#cart-notification .bss-checkout',
            checkoutSelector: '#cart-notification .bss-checkout'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '.cart__ctas',
            checkoutSelector: '.cart__footer #checkout'
        }
    },
    taxExempt: {
       miniCart: {
            position: 'beforeBegin',
            selector: '.cart-notification__links'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__ctas'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.cart-notification__links'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__ctas'
        }
    }
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.price__container, cart-items .price {
    visibility: hidden;
}

.price__container span, cart-items .price span {
    font-size: inherit !important;
    color: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
}`;document.head.appendChild(style);},},"Sense":{anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '#cart-notification .bss-checkout',
            checkoutSelector: '#cart-notification .bss-checkout'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '.cart__ctas',
            checkoutSelector: '.cart__footer #checkout'
        }
    },
    taxExempt: {
       miniCart: {
            position: 'beforeBegin',
            selector: '.cart-notification__links'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__ctas'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.cart-notification__links'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__ctas'
        }
    }
},coreJS: () => {window.KC.observe('#cart-notification', { type: 'class' }, (classList) => {
    if (classList.contains('active')) {
        window.KC.init();
    }
});
;const style = document.createElement("style"); style.innerHTML = `#cart-notification #bss-b2b-net-term-button-wrapper {
    margin-top: 10px;
}
.bss-vat-exempt-form-header-text {
    margin: 0 !important;
}
.bss-vat-exempt-form-header-text {
    font-size: 18px !important;
}
.bss-vat-exempt-form-subtitle-text {
    font-size: 12px !important;
}
.bss-b2b-translation-dc-form_header_text {
    font-weight: 500 !important;
    font-size: 18px !important;
}
.bss-b2b-discount-code-wrapper {
    margin-bottom: 15px !important;
}`;document.head.appendChild(style);},},"Refresh":{anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.drawer__footer .cart__ctas',
            checkoutSelector: '.drawer__footer #CartDrawer-Checkout'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '.cart__footer .cart__ctas',
            checkoutSelector: '.cart__footer #checkout'
        }
    },
    taxExempt: {
       miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer .cart__ctas'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__ctas'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer .cart__ctas'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__ctas'
        }
    }
},coreJS: () => {if (typeof window.KC.waitForExist === 'function' && window.KC.page.isCartPage()) {
    window.KC.waitForExist(
        () => document.querySelector("cart-drawer"),
        () => {
            document.querySelector("cart-drawer")?.remove();
            document.querySelector("#CartDrawer")?.remove();
        },
        5000
    );
}

window.KC.observe('cart-drawer', { type: 'class' }, (classList) => {
    if (classList.contains('active')) {
        window.KC.cloneCheckout();
        window.KC.init();
        
    }
});;const style = document.createElement("style"); style.innerHTML = `div#bss-b2b-net-term-button-wrapper {
    margin-top: 10px;
}
.bss-vat-exempt-form-header-text {
    margin: 0 !important;
}
.bss-vat-exempt-form-header-text {
    font-size: 18px !important;
}
.bss-vat-exempt-form-subtitle-text {
    font-size: 12px !important;
}
.bss-b2b-translation-dc-form_header_text {
    font-weight: 500 !important;
    font-size: 18px !important;
}
.bss-b2b-discount-code-wrapper {
    margin-bottom: 15px !important;
}`;document.head.appendChild(style);},},"Flow":{selector:{
    collection: {
        selectorCard: "",
        selectorPrice: "",
        selectorQuickviewBtn: ""
    },
    product: {
        selectorForm: ".product-single__information",
        selectorPrice: '.product-price__price',
    },
    miniCart: {
        selectorCard: ".ajaxcart__product",
        selectorOriginPrice: ".product-price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".subtotal span:last-child",
    },
    cart: {
        selectorCard: "",
        selectorOriginPrice: "",
        selectorFinalLinePrice: "",
        selectorSubtotalPrice: ""
    },
    quickView: {
        selectorCard: "",
        selectorPrice: ""
    }
},coreJS: () => {window.KC.observe('#UpcartPopup', { type: 'class' }, (classList) => {
    if (classList.contains('upcartPopupShow')) {
        window.KC.init();
    }
});;},},"Maranello":{coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.bss-b2b-tax-ex-wrapper {
    width: fit-content !important;
    margin-left: auto !important;
}

.mini-cart-bss-te .bss-b2b-tax-ex-wrapper {
    margin: 0 auto;
}

.bss-b2b-vat-selected {
    max-width: fit-content;
    border-radius: 4px 0 0 4px !important;
}

.bss-b2b-vat-input {
    border-radius: 0 4px 4px 0 !important;
    transform: translateX(-1px);
}

.bss-b2b-tax-ex-wrapper {
    margin-left: 20% !important;
}

span.bss-b2b-translation-vat-form_validate_country_code_message {
    color: black;
}

[show-message="VAT_VALIDATECOUNTRY"] .tax-icon-error {
    opacity: 0;
    position: absolute;
}`;document.head.appendChild(style);},},"Eurus":{selector:{
    collection: {
        selectorCard: ".grid-item .card-product, .card-product, #cart-upsell-drawer",
        selectorPrice: ".card-product .price,  #cart-upsell-drawer .price",
        selectorQuickviewBtn: ".button-text, #cart-upsell-drawer .button-action",
    },
    product: {
        selectorForm: ".product-content-container",
        selectorPrice: '[id^="price-template--"]',
    },
    miniCart: {
        selectorCard: "#update-cart",
        selectorOriginPrice: null,
        selectorFinalLinePrice: "#update-cart .price",
        selectorSubtotalPrice: "#total-price",
    },
    cart: {
        selectorCard: "#main-cart-items",
        selectorOriginPrice: "#main-cart-items .price:not([class*='cart-item-price-'])",
        selectorFinalLinePrice: "#main-cart-items .price[class*='cart-item-price-']",
        selectorSubtotalPrice: null,
    },
    quickView: {
        selectorCard: '[id^="choose-options-template--"], #quickview-product-content',
        selectorPrice: ".grid-item .card-product .price, #quickview-product-content .price",
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.footer-cart-drawer-mobile > div:nth-child(2)',
            checkoutSelector: '.footer-cart-drawer-mobile #checkout-submit'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '#checkout-submit',
            checkoutSelector: '#checkout-submit'
        }
    }
},coreJS: () => {
const inputSearchSelector = `.input-search`;
let debounceTimer;

document.addEventListener("input", (e) => {
  if (e.target && e.target.matches(inputSearchSelector)) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  }
});

document.addEventListener("click", (e) => {
  if (e.target && e.target.closest(".header-icon-cart")) {
    setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 1500)
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const target = document.querySelector('#CartDrawer');
      if (target) {
          const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                  if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                      const style = target.getAttribute('style');
                      if (!style || style.trim() === '') {
                        window.dispatchEvent(new Event('scroll'));
                      }
                  }
              });
          });
          observer.observe(target, {
              attributes: true,
              attributeFilter: ['style']
          });
      }
    }, 300);
  }
}, { once: true });

document.addEventListener("bss_b2b:CustomCartUpdate", e => {
    setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 1500)
});},},"Motion":{selector:{
    collection: {
        selectorCard: ".grid__item.grid-product",
        selectorPrice: ".grid-product__price",
        selectorQuickviewBtn: null
    },
    product: {
        selectorForm: ".product-single__information",
        selectorPrice: '.product-price__price',
    },
    miniCart: {
        selectorCard: ".ajaxcart__product",
        selectorOriginPrice: ".product-price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".subtotal span:last-child",
    },
    cart: {
        selectorCard: "",
        selectorOriginPrice: "",
        selectorFinalLinePrice: "",
        selectorSubtotalPrice: ""
    },
    quickView: {
        selectorCard: "",
        selectorPrice: ""
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.boost-sd__button.boost-sd__btn-checkout',
            checkoutSelector: '.boost-sd__button.boost-sd__btn-checkout'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '.cart__footer .cart__checkout-wrapper',
            checkoutSelector: '.cart__checkout'
        }
    }
},coreJS: () => {window.KC.observe('body', { type: 'class' }, (classList) => {
    if (classList.contains('modal-open-cart')) {
        window.KC.cloneCheckout();
        window.KC.init();
        
    }
});;const style = document.createElement("style"); style.innerHTML = `.b2b-nt-modal-overlay {
    z-index: 999999 !important;
}

#bss-b2b-net-term-button {
    justify-content: center !important;
}

.cart__footer #bss-b2b-net-term-button-wrapper {
    margin-top: 10px;
}`;document.head.appendChild(style);},},"Maximize":{selector:{
    collection: {
        selectorCard: ".grid-item .card-product, #cart-upsell-drawer",
        selectorPrice: ".grid-item .card-product .price, #cart-upsell-drawer .price",
        selectorQuickviewBtn: ".button-text, #cart-upsell-drawer .button-action",
    },
    product: {
        selectorForm: ".product-content-container",
        selectorPrice: '[id^="price-template--"]',
    },
    miniCart: {
        selectorCard: "#update-cart",
        selectorOriginPrice: null,
        selectorFinalLinePrice: "#update-cart .price",
        selectorSubtotalPrice: "#total-price",
    },
    cart: {
        selectorCard: "#main-cart-items",
        selectorOriginPrice: "#main-cart-items .price:not([class*='cart-item-price-'])",
        selectorFinalLinePrice: "#main-cart-items .price[class*='cart-item-price-']",
        selectorSubtotalPrice: null,
    },
    quickView: {
        selectorCard: '[id^="choose-options-template--"], #quickview-product-content',
        selectorPrice: ".grid-item .card-product .price, #quickview-product-content .price",
    }
},},"Concept":{selector:{
    collection: {
        selectorCard: ".product-card.product-card--card",
        selectorPrice: ".product-card__content .price",
        selectorQuickviewBtn: ".quick-add .button.button--primary",
    },
    product: {
        selectorForm: "product-info",
        selectorPrice: '.product__price',
    },
    miniCart: {
        selectorCard: ".horizontal-product",
        selectorOriginPrice: ".horizontal-product__details .price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".totals__subtotal-value",
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart-item__details .price",
        selectorFinalLinePrice: "cart-items .text-right .price",
        selectorSubtotalPrice: ".totals__subtotal-value",
    },
    quickView: {
        selectorCard: ".quick-view__content",
        selectorPrice: "quick-view .price" 
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.drawer__footer-buttons',
            checkoutSelector: 'form button[name="checkout"]'
        },
        cartPage: {
            position: 'afterEnd',
            selector: 'button[name="checkout"]',
            checkoutSelector: 'button[name="checkout"]'
        }
    },
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer-bottom'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button[name="checkout"]'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer-bottom'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button[name="checkout"]'
        }
    }
},},"Horizon":{selector:{
    collection: {
        selectorCard: ".product-card__content",
        selectorPrice: "product-price .price",
        selectorQuickviewBtn: ".button.quick-add__button",
        selectorSearchBar: ".predictive-search-dropdown"
    },
    product: {
        selectorForm: ".product-details",
        selectorPrice: "product-price .price",
    },
    miniCart: {
        selectorCard: "tbody .cart-items__table-row",
        selectorOriginPrice: ".cart-items__details div span:not(.visually-hidden)",
        selectorFinalLinePrice: ".cart-items__price text-component",
        selectorSubtotalPrice: ".cart__total-value",
    },
    cart: {
        selectorCard: ".cart-items__table-row",
        selectorOriginPrice: ".cart-items__details div span:not(.visually-hidden)",
        selectorFinalLinePrice: ".cart-items__price text-component",
        selectorSubtotalPrice: ".cart__total-value",
    },
    quickView: {
        selectorCard: ".quick-add-modal__content",
        selectorPrice: 'product-price [ref="priceContainer"]' 
    },
    searchBar: { 
        selectorCard: '.predictive-search-results__card', 
        selectorPrice: '[ref="priceContainer"]'
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.drawer__footer-buttons',
            checkoutSelector: 'form button[name="checkout"]'
        },
        cartPage: {
            position: 'afterEnd',
            selector: 'button[name="checkout"]',
            checkoutSelector: 'button[name="checkout"]'
        }
    },
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer-bottom'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button[name="checkout"]'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer-bottom'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button[name="checkout"]'
        }
    }
},coreJS: () => {const isPDP = window.location.pathname.includes("/products/");
if(isPDP) {
  let oldHref = location.href;
  new MutationObserver(() => {
    if (oldHref !== location.href) {
      oldHref = location.href;
      const variant = new URL(location.href).searchParams.get('variant');
      setTimeout(() => {
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
  BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
      }, 600)
    }
  }).observe(document, {subtree: true, childList: true});
}

window.KC.observe('cart-drawer__dialog', { type: 'class' }, (classList) => {
    if (classList.contains('open')) {
      window.KC.cloneCheckout();
      window.KC.init();
    }
});

document.addEventListener("click", (e) => {
  if (e.target && e.target.closest(".header-actions__cart-icon")) {
    setTimeout(() => {
      const target = document.querySelector('.cart-drawer__dialog');
      if (target && target.hasAttribute("open")) 
         document.dispatchEvent(new Event('bss_b2b:CustomCartUpdate'));
                    
    }, 300);
  }
}, 1);;},},"Flux":{selector:{
    collection: {
        selectorCard: '.card-wrapper',
        selectorPrice: '.price',
        selectorQuickviewBtn: ".quick-add__submit"
    },
    searchBar: { 
        selectorCard: '.predictive-search__list-item', 
        selectorPrice: '.price' 
    },
    product: { 
        selectorForm: 'product-info', 
        selectorPrice: '.price' 
    },
    miniCart: {
        selectorCard: '[id^="CartDrawer-Item"].cart-item',
        selectorOriginPrice: '.cart-item-details > div.product-option',
        selectorFinalLinePrice: '.cart-item-price-wrapper .price.price--end',
        selectorSubtotalPrice: '.totals-subtotal-value',
    },
    cart: {
        selectorCard: '[id^="CartItem"].cart-item',
        selectorOriginPrice: '.cart-item-details > div.product-option',
        selectorFinalLinePrice: '.cart-item-price-wrapper .price.price--end',
        selectorSubtotalPrice: '.totals-subtotal-value',
    },
    quickView: { 
        selectorCard: 'quick-add-modal product-info', 
        selectorPrice: '.price' 
    }
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.product-grid-container .price span {
    color: #fff;
}

.bss-checkout:disabled { 
    cursor: not-allowed;
    opacity: .5 !important;
}`;document.head.appendChild(style);},},"Avante":{selector:{
    collection: {
        selectorCard: ".grid__item",
        selectorPrice: ".price__wrapper",
        selectorQuickviewBtn: "quick-view-button"
    },
    product: {
        selectorForm: ".product__info-container",
        selectorPrice: '.regular-price',
    },
    miniCart: {
        selectorCard: "cart-drawer tbody .cart-item",
        selectorOriginPrice: "cart-drawer price-money.original-price bdi",
        selectorFinalLinePrice: "cart-drawer .cart-item__totals.right price-money bdi",
        selectorSubtotalPrice: "cart-drawer .totals__subtotal-value",
    },
    cart: {
        selectorCard: "cart-items .cart-item",
        selectorOriginPrice: "cart-items price-money.original-price bdi",
        selectorFinalLinePrice: "cart-items .cart-item__totals.right price-money bdi",
        selectorSubtotalPrice: "cart-items .totals__subtotal-value"
    },
    quickView: {
        selectorCard: ".popup-wrapper.popup-wrapper__quick-view",
        selectorPrice: ".price__wrapper"
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.drawer__footer-actions',
            checkoutSelector: '#CartDrawer-Checkout'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '.cart-page .cart__checkout',
            checkoutSelector: '#checkout'
        }
    }
},},"Enterprise":{coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.bss-b2b-vat-input {
    border: 2px solid rgba(42 43 42 / .2);
    border-radius: 0 28px 28px 0;
}
.bss-b2b-vat-selected {
    border-radius: 28px 0 0 28px !important;
    transform: translateX(2px);
}`;document.head.appendChild(style);},},"Outsiders":{anchor:{
    discountCodes: {
        miniCart: {
            position: 'afterBegin',
            selector: '.cart-drawer__footer'
        },
        cartPage: {
            position: 'afterBegin',
            selector: '#main-cart-footer'
        }
    }
},},"Impact":{anchor:{
      netterm: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.buy-buttons.buy-buttons--compact',
            checkoutSelector: 'button[name="checkout"]'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button[name="checkout"]',
            checkoutSelector: '.cart button[name="checkout"]'
        }
    },
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.buy-buttons.buy-buttons--compact'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart button[name="checkout"]'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.buy-buttons.buy-buttons--compact'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart button[name="checkout"]'
        }
    }
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.cart-drawer__inner #bss-b2b-net-term-button {
    width: 100% !important;
    justify-content: center !important;
}

cart-drawer:not([open]) .bss-checkout {
    display: none !important;
}`;document.head.appendChild(style);},},"Viola":{selector:{
    collection: {
        selectorCard: ".grid__item",
        selectorPrice: ".price__container",
        selectorQuickviewBtn: ".button.quick_shop.js-wbquickview-link"
    },
    product: {
        selectorForm: ".product__info-wrapper",
        selectorPrice: '.price__container',
    },
    miniCart: {
        selectorCard: "cart-drawer-items .cart-item",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart-item__totals .price",
        selectorSubtotalPrice: ".drawer__footer .totals__subtotal-value",
    },
    cart: {
        selectorCard: "cart-items .cart-item",
        selectorOriginPrice: "cart-items .product-option.bss-original-price",
        selectorFinalLinePrice: "#main-cart-items  .price.bss-final-price",
        selectorSubtotalPrice: "#main-cart-footer .totals__subtotal-value"
    },
    quickView: {
        selectorCard: "#wbquickview",
        selectorPrice: ".price__container"
    }
},},"Stretch":{selector:{
    collection: {
        selectorCard: "product-card",
        selectorPrice: ".price-list ",
        selectorQuickviewBtn: ".product-card__quick-buy button"
    },
    product: {
        selectorForm: ".product-info__block-list",
        selectorPrice: '.price-list',
    },
    miniCart: {
        selectorCard: ".rebuy-cart__flyout-item, line-item",
        selectorOriginPrice: ".rebuy-cart__flyout-item-price",
        selectorFinalLinePrice: ".line-item__line-price",
        selectorSubtotalPrice: ".rebuy-cart__flyout-subtotal-amount span:nth-child(2), .cart-drawer__footer-inner .medium:nth-child(2)",
    },
    cart: {
        selectorCard: ".cart .order-summary__body tr",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart .order-summary__body tr td:nth-child(3) span",
        selectorSubtotalPrice: ".cart__right span[bss-b2b-cart-total-price]"
    },
    quickView: {
        selectorCard: "#quick-buy-modal-content",
        selectorPrice: ".price-list"
    }
},},"Flex":{selector:{
    collection: {
        selectorCard: ".product__grid-item",
        selectorPrice: ".product-thumbnail__price.price",
        selectorQuickviewBtn: ".quick_shop.button.js-quick-shop-link"
    },
    product: {
        selectorForm: ".product__information",
        selectorPrice: '.money.tpo_product_price',
    },
    miniCart: {
        selectorCard: null,
        selectorOriginPrice: null,
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: null,
    },
    cart: {
        selectorCard: ".cart__item",
        selectorOriginPrice: ".cart__item-price-col",
        selectorFinalLinePrice: ".money.tpo_cart_item_price",
        selectorSubtotalPrice: ".cart__subtotal .money"
    },
    quickView: {
        selectorCard: "#quickshop",
        selectorPrice: ".price"
    }
},},"Brooklyn Workdone EU":{selector:{
    collection: {
        selectorCard: ".grid__item.grid-product",
        selectorPrice: ".grid-product__price",
        selectorQuickviewBtn: null
    },
    product: {
        selectorForm: ".product-single__meta",
        selectorPrice: '.product-single__price',
    },
    miniCart: {
        selectorCard: null,
        selectorOriginPrice: null,
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: null,
    },
    cart: {
        selectorCard: ".cart__row",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart__price",
        selectorSubtotalPrice: ".total-price .cart__subtotal"
    },
    quickView: {
        selectorCard: null,
        selectorPrice: null
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.drawer__footer .cart__ctas',
            checkoutSelector: '.drawer__footer #CartDrawer-Checkout'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '.cart__footer .cart__ctas',
            checkoutSelector: '.cart__footer #checkout'
        }
    },
    taxExempt: {
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__row.cart__row--last'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer .cart__ctas'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__ctas'
        }
    }
},},"Team Line Custom Theme":{selector:{
    collection: {
        selectorCard: ".collection-grid__item",
        selectorPrice: ".product-card__price",
        selectorQuickviewBtn: null,
        selectorSearchBar: ".header.header--sticky"
    },
    product: {
        selectorForm: ".product-single__information",
        selectorPrice: '.product-price__price',
    },
    miniCart: {
        selectorCard: ".cart-drawer__items .cart-item",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart-item__price",
        selectorSubtotalPrice: ".cart-drawer__subtotal-price",
    },
    cart: {
        selectorCard: ".cart-page__row",
        selectorOriginPrice: ".cart-page__price",
        selectorFinalLinePrice: "",
        selectorSubtotalPrice: ".cart-page__subtotal-value"
    },
    quickView: {
        selectorCard: "",
        selectorPrice: ""
    },
    searchBar: { 
        selectorCard: '.search-overlay__results', 
        selectorPrice: '.product-card__price' 
    },
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `[bss-b2b-item-original-price]:has(span+span) {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}`;document.head.appendChild(style);},},"Primavera":{selector:{
    collection: {
        selectorCard: ".card.card-product",
        selectorPrice: ".price__values",
        selectorQuickviewBtn: ".card-product__quick-add.quick-add__submit.button"
    },
    product: {
        selectorForm: ".product-info__blocks",
        selectorPrice: '.price__values',
    },
    miniCart: {
        selectorCard: "#cart-drawer-items .cart-item",
        selectorOriginPrice: "#cart-drawer-items .cart-item__product .cart-item__price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".cart-drawer__footer .cart-footer__line",
    },
    cart: {
        selectorCard: "#cart-page-items .cart-item",
        selectorOriginPrice: "#cart-page-items .cart-item__price",
        selectorFinalLinePrice: "#cart-page-items .cart-item__price-wrapper",
        selectorSubtotalPrice: ".cart-page__footer .cart-footer__line"
    },
    quickView: {
        selectorCard: ".quick-add__body",
        selectorPrice: ".price__values"
    }
},},"Futurer":{anchor:{
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.xo-cart-mini-footer'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.xo-main-cart__wrapper'
        } 
    }
},},"Electro":{selector:{
    collection: {
        selectorCard: ".card__info",
        selectorPrice: ".price",
        selectorQuickviewBtn: ".btn-quickbuy",
    },
    product: {
        selectorForm: ".main-product-info-container",
        selectorPrice: '.price',
    },
    miniCart: {
        selectorCard: ".cart-drawer__product",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart-drawer__product-price",
        selectorSubtotalPrice: ".js-cart-total p",
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart-item__price",
        selectorSubtotalPrice: ".js-cart-total p",
    },
    quickView: {
        selectorCard: ".product__quickview",
        selectorPrice: ".price" 
    }
},coreJS: () => {const targetNode = document.querySelector('.js-dialog-body');

const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.target.classList.contains('js-variant-select-option-name')) {
        document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`)) 
    }
  });
});

observer.observe(targetNode, {
  childList: true, 
  subtree: true,
});

document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`#predictiveSearch_Input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});
;},},"Minimog - OS 2.0":{selector:{
    collection: {
        selectorCard: ".m-product-item",
        selectorPrice: ".m-product-card__price>span",
        selectorQuickviewBtn: ".m-product-quickview-button",
    },
    product: {
        selectorForm: ".m-main-product--info",
        selectorPrice: '.m-price',
    },
    miniCart: {
        selectorCard: ".m-cart-drawer-item",
        selectorOriginPrice: ".m-cart-item__price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".m-cart__subtotal--price",
    },
    cart: {
        selectorCard: ".m-cart-item",
        selectorOriginPrice: ".m-cart-item__price",
        selectorFinalLinePrice: ".m-cart__column--subtotal",
        selectorSubtotalPrice: ".m-cart__subtotal--price",
    },
    quickView: {
        selectorCard: ".m-product-quickview",
        selectorPrice: ".m-price" 
    }
},coreJS: () => {document.querySelectorAll(".m-product-quickview-button").forEach((btn) => {
    btn.addEventListener("click", () => {
        setTimeout(() => {
            document.dispatchEvent(
                new Event("bss_b2b:QuickviewLoaded")
            );
        }, 700)

    });
});;},},"Vision":{selector:{
    collection: {
        selectorCard: "product-card",
        selectorPrice: ".product-card-info .price",
        selectorQuickviewBtn: ".product-card-quickview"
    },
    product: {
        selectorForm: ".product-information",
        selectorPrice: '.price',
    },
    miniCart: {
        selectorCard: "cart-drawer .product-cart-item",
        selectorOriginPrice: null,
        selectorFinalLinePrice: "cart-drawer .product-cart-item-price .price",
        selectorSubtotalPrice: ".cart-drawer-footer .price",
    },
    cart: {
        selectorCard: ".thb-cart-form--form tbody tr",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart-items .price",
        selectorSubtotalPrice: ".thb-cart-collaterals .price"
    },
    quickView: {
        selectorCard: "#Product-Drawer-Content",
        selectorPrice: ".product-price-container .price"
    }
},},"Empire":{selector:{
    collection: {
        selectorCard: ".productitem",
        selectorPrice: ".price.productitem__price ",
        selectorQuickviewBtn: "[data-quickshop-full]",
    },
    product: {
        selectorForm: ".product-main",
        selectorPrice: '.price.product__price ',
    },
    miniCart: {
        selectorCard: ".atc--product",
        selectorOriginPrice: ".atc--product-details--price-value.money",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".atc-subtotal--price.money"
    },
    cart: {
        selectorCard: ".cartitems .cart-item",
        selectorOriginPrice: ".cart-item--content-price",
        selectorFinalLinePrice: ".cart-item__total .money",
        selectorSubtotalPrice: ".cart-title-total .money",
    },
    quickView: {
        selectorCard: '.modal--quickshop-full .product-main',
        selectorPrice: ".price.product__price ",
    }
},coreJS: () => {const quickviewElement = document.querySelector('.modal');

if (quickviewElement) {
    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class'
            ) {
                if (quickviewElement.classList.contains('modal--quickshop-full')) {
                    console.log(123);
                    setTimeout(() => {
                        document.dispatchEvent(
                            new Event('bss_b2b:QuickviewLoaded')
                        );
                    }, 1000)

                }
            }
        });
    });

    observer.observe(quickviewElement, {
        attributes: true,
        attributeFilter: ['class'],
    });
};},},"Xtra":{selector:{
    collection: {
        selectorCard: ".product-card",
        selectorPrice: ".price",
        selectorQuickviewBtn: ":not(*)",
        selectorSearchBar: ":not(*)",
    },
    product: {
        selectorForm: "#main-product div.f8pr",
        selectorPrice: ".price",
    },
    miniCart: {
        selectorCard: "#cart > ul.l4ca li",
        selectorOriginPrice: ":not(*)",
        selectorFinalLinePrice: ".price",
        selectorSubtotalPrice: "#cart ul.l4tt li .price",
    },
    cart: {
        selectorCard: ".form-cart ul.l4ca li",
        selectorOriginPrice: ":not(*)",
        selectorFinalLinePrice: ":scope > .price",
        selectorSubtotalPrice: ".form-cart ul.l4tt li .price",
    },
    quickView: {
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    },
    searchBar: {
        selectorCard: "#livesearch ul.l4ca",
        selectorPrice: ".price",
    }
},coreJS: () => {if (!BSS_B2B.page.isProductPage()) {
    window.addEventListener('bss_b2b:loadedObserver', () => {
        setTimeout(() => {
            window.dispatchEvent(new Event('scroll'));
        }, 0);
    });
}

document.addEventListener("click", (e) => {
    if (!e.target || !e.target.closest('#nav-user [href="/cart"]')) return;
    const threshold = 10000;
    let elapsed = 0;
    const intervalId = setInterval(() => {
        const target = document.querySelector('#cart');
        if (target && target.getAttribute("aria-hidden") === "false" && target.querySelector(".price")) {
            clearInterval(intervalId);
            document.dispatchEvent(new Event('bss_b2b:CustomCartUpdate'));
        } else if (elapsed >= threshold) clearInterval(intervalId);
        else elapsed += 200;
    }, 200)
});;const style = document.createElement("style"); style.innerHTML = `.price:not([bss-b2b-product-id]) {
    visibility: hidden;
}`;document.head.appendChild(style);},},"Expanse":{selector:{
    collection: {
        selectorCard: ".product-grid-item",
        selectorPrice: ".element-price",
        selectorQuickviewBtn: ".tool-tip-trigger"
    },
    product: {
        selectorForm: ".product-grid__content",
        selectorPrice: '.element-price',
    },
    miniCart: {
        selectorCard: ".cart__item",
        selectorOriginPrice: ".cart__price.element-price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".cart__item--subtotal .element-price",
    },
    cart: {
        selectorCard: ".cart__item",
        selectorOriginPrice: ".cart__price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".cart__item--subtotal .element-price"
    },
    quickView: {
        selectorCard: ".tool-tip__content",
        selectorPrice: ".element-price"
    }
},},"Canopy":{selector:{
    collection: {
        selectorCard: ".js-pagination-result",
        selectorPrice: ".product-card__price",
        selectorQuickviewBtn: null
    },
    product: {
        selectorForm: ".product-info",
        selectorPrice: '.product-info__price',
    },
    miniCart: {
        selectorCard: ".cart-drawer__content .cart-item",
        selectorOriginPrice: ".cart-drawer__content .cart-item__details .price__current",
        selectorFinalLinePrice: ".cart-drawer__content .cart-item__total .price__current",
        selectorSubtotalPrice: ".cart-drawer__summary div.font-bold",
    },
    cart: {
        selectorCard: ".cart__items .cart-item",
        selectorOriginPrice: ".cart__items .cart-item__details .price__current",
        selectorFinalLinePrice: ".cart__items .cart-item__total .price__current",
        selectorSubtotalPrice: ".cart__summary:last-child p:last-child"
    },
    quickView: {
        selectorCard: "",
        selectorPrice: ""
    }
},},"Gecko":{selector:{
    collection: {
        selectorCard: ".t4s-product-wrapper",
        selectorPrice: ".t4s-product-price",
        selectorQuickviewBtn: ":not(*)",
    },
    product: {
        selectorForm: ".t4s-product__info-container",
        selectorPrice: ".t4s-product-price",
    },
    miniCart: {
        selectorCard: ".t4s-mini_cart__item",
        selectorOriginPrice: ".t4s-cart_price",
        selectorFinalLinePrice: ":not(*)",
        selectorSubtotalPrice: ".t4s-cart__totalPrice",
    },
    cart: {
        selectorCard: ".t4s-page_cart__item",
        selectorOriginPrice: ".t4s-cart_price",
        selectorFinalLinePrice: ".t4s-cart-item-price",
        selectorSubtotalPrice: ".t4s-cart__totalPrice",
    },
    quickView: {
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    },
    searchBar: {
        selectorCard: ".t4s-pr-search__wrap .t4s-widget__pr",
        selectorPrice: ".t4s-widget__pr-price",
        selectorSearchBar: ".t4s-pr-search__wrap",
    }
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.t4s-product-price, .t4s-cart_price, .t4s-cart-item-price, .t4s-cart__totalPrice, .t4s-widget__pr-price {
    visibility: hidden;
}

.t4s-product-price span, .t4s-cart_price span, .t4s-cart-item-price span, .t4s-cart__totalPrice span, .t4s-widget__pr-price span {
    font-size: inherit !important;
    color: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
}`;document.head.appendChild(style);},},"Blum":{selector:{
    collection: {
        selectorCard: ".product-card",
        selectorPrice: ".price",
        selectorQuickviewBtn: ".quickbuy__btn",
        selectorSearchBar: "#predictiveSearch_Input"
    },
    product: {
        selectorForm: ".main-product-info-container",
        selectorPrice: ".price",
    },
    miniCart: {
        selectorCard: ".cart-drawer__product",
        selectorOriginPrice: ".cart-drawer__product-price .ta-right",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".js-cart-total p",
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".cart-item__price-wrapper .wb-break-word.d-flex.fd-column",
        selectorSubtotalPrice: ".js-cart-total p",
    },
    quickView: {
        selectorCard: ".js-quick-view-container",
        selectorPrice: '.price' 
    },
    searchBar: { 
        selectorCard: '.search__result-item', 
        selectorPrice: '.price'
    }
},coreJS: () => {document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`#predictiveSearch_Input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});

 const quickView = document.querySelector('sht-dialog-quickshop');

  if (!quickView) {
    return;
  }

  const config = {
    attributes: true,
    attributeFilter: ['hidden']
  };

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'hidden'
      ) {
        const isHidden = quickView.hasAttribute('hidden');

        if (!isHidden) {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))  
        } 
         
      }
    });
  });

  observer.observe(quickView, config);;const style = document.createElement("style"); style.innerHTML = `.js-quick-view-container .price[bss-b2b-product-id]>span {
    color: #ffffff !important;
}`;document.head.appendChild(style);},},"Shrine PRO":{selector:{
    collection: {
        selectorCard: ".grid__item",
        selectorPrice: ".card-information .price",
        selectorQuickviewBtn: null
    },
    product: {
        selectorForm: "product-info",
        selectorPrice: '.product-page-price .price',
    },
    miniCart: {
        selectorCard: "#CartDrawer-Form .cart-drawer-item",
        selectorOriginPrice: null,
        selectorFinalLinePrice: "#CartDrawer-Form .cart-item__discounted-prices",
        selectorSubtotalPrice: ".cart-drawer__totals__row__money.total_price"
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart-item__details .product-option.original-price",
        selectorFinalLinePrice: ".cart-item__price-wrapper .price.price--end",
        selectorSubtotalPrice: ".totals__subtotal-value"
    },
    quickView: {
        selectorCard: "",
        selectorPrice: ""
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.cart__ctas',
            checkoutSelector: '#CartDrawer-Checkout'
        },
        cartPage: {
            position: 'afterEnd',
            selector: '#checkout',
            checkoutSelector: '#checkout'
        }
    },
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.cart-drawer__footer'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__blocks'
        }
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.cart-drawer__footer'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart__blocks'
        }
    }
},},"Release":{selector:{
    collection: {
        selectorCard: ".product-card",
        selectorPrice: ".price",
        selectorSearchBar: "#search-desktop"
    },
    product: {
        selectorForm: ".product-grid__sticky .product__content",
        selectorPrice: ".price",
    },
    miniCart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart-item__content .cart-item__price",
        selectorFinalLinePrice: ".cart-item__actions--price .cart-item__price",
        selectorSubtotalPrice: ".cart-drawer__total-price",
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart-item__price-content .cart-item__price",
        selectorFinalLinePrice: ".cart-item__total-price .cart-item__price",
        selectorSubtotalPrice: ".cart__summary-total-price",
    },
    quickView: {
        selectorCard: ".quick-add-modal__content",
        selectorPrice: 'product-price [ref="priceContainer"]' 
    },
    searchBar: { 
        selectorCard: '.predictive-search__results .product-card', 
        selectorPrice: '.price'
    }
},anchor:{
   netterm: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.cart-drawer__action-buttons',
            checkoutSelector: '.cart-drawer__action-buttons .bss-checkout'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart-drawer__action-buttons',
            checkoutSelector: '.cart-drawer__action-buttons #checkout'
        }
    },
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.cart-drawer__action-buttons',
            checkoutSelector: '.cart-drawer__action-buttons .bss-checkout'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart-drawer__action-buttons',
            checkoutSelector: '.cart-drawer__action-buttons #checkout'
        }
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.cart-drawer__action-buttons',
            checkoutSelector: '.cart-drawer__action-buttons .bss-checkout'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: '.cart-drawer__action-buttons',
            checkoutSelector: '.cart-drawer__action-buttons #checkout'
        }
    }
},},"Palo Alto":{selector:{
    collection: {
        selectorCard: ".product-grid-item",
        selectorPrice: ".price",
        selectorQuickviewBtn: ".btn-quick-buy",
        selectorSearchBar: "predictive-search",
    },
    product: {
        selectorForm: "product-info .product-single__details",
        selectorPrice: ".product__price",
    },
    miniCart: {
        selectorCard: "#cart-drawer .cart__item",
        selectorOriginPrice: ".cart__item__price",
        selectorFinalLinePrice: ":not(*)",
        selectorSubtotalPrice: ".cart__total__money",
    },
    cart: {
        selectorCard: ".cart .cart__item",
        selectorOriginPrice: ".cart__item__price",
        selectorFinalLinePrice: ".product__price--regular[data-product-price]",
        selectorSubtotalPrice: ".cart__total__money",
    },
    quickView: {
        qvSelector: ".popup-quick-view .popup-quick-view__inner",
        selectorCard: "product-info .popup-quick-view__form",
        selectorPrice: ".product__price",
    },
    searchBar: {
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    }
},coreJS: () => {function process(input) {
    const form = input.closest('[bss-b2b-product-form][bss-b2b-product-form-id]');
    const variantPriceEl = form?.querySelector('.product__price span:last-child');
    const totalPriceEl = form?.querySelector('button[data-add-to-cart] .product__price--regular');
    
    if (!form || !variantPriceEl || !totalPriceEl) {
        totalPriceEl.style.visibility = "visible";
        return;
    }

    const { price } = BSS_B2B.storage.productFormStorage.get(form.getAttribute('bss-b2b-product-form-id')).currentVariant;
    let currPrice = Number(variantPriceEl.textContent.replace(/[^0-9.-]+/g, "")) * 100;
    if (price === currPrice) {
        totalPriceEl.style.visibility = "visible";
        return;
    }
    
    totalPriceEl.textContent = BSS_B2B.formatMoney(currPrice * Number(input.value));
    totalPriceEl.style.visibility = "visible";
}

if (BSS_B2B.page.isProductPage()) {
    const input = document.querySelector('.quantity__selector.quantity__input');
    if (!input) return;
    setTimeout(() => process(input), 2500);
}

window.addEventListener("bss_b2b:loadedObserver", () => {
    const fn = () => {
        const input = document.querySelector('.quantity__selector.quantity__input');
        if (!input) return;
        process(input);
    };
    const { productObserver } = BSS_B2B.observer;
    productObserver.takeLatest('VariantChange', fn, {
        priority: 1000,
    });
    productObserver.takeLatest('QuickviewLoaded', fn, {
        priority: 1000,
    });
    productObserver.takeEvery(`InputQuantityChange`, fn, {
        priority: 1000,
    });
});

const cartBtn = document.querySelector('.menu__item--icons .cart__toggle');
if (!cartBtn) return;
cartBtn.addEventListener('click', () => setTimeout(() => document.dispatchEvent(new Event('bss_b2b:CustomCartUpdate')), 100));;const style = document.createElement("style"); style.innerHTML = `.price, .product__price, .cart__item__price, button[data-add-to-cart] .product__price--regular, .cart__total__money {
    visibility: hidden;
}`;document.head.appendChild(style);},},"Parallax":{selector:{
    collection: {
        selectorCard: ".one-third.column",
        selectorPrice: ".info .price",
        selectorQuickviewBtn: null
    },
    product: {
        selectorForm: ".seven.columns.omega",
        selectorPrice: '.modal_price .price',
    },
    miniCart: {
        selectorCard: ".cart_item",
        selectorOriginPrice: ".item_info .price",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".mm-label .mm-counter.price"
    },
    cart: {
        selectorCard: ".five.columns.omega",
        selectorOriginPrice: ".price_total .money",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".subtotal_amount .money"
    },
    quickView: {
        selectorCard: "",
        selectorPrice: ""
    }
},},"Ignite":{selector:{
    collection: {
        selectorCard: ".collection ul li, .predictive-search__list-item, .complementary-products .mini-card-list li",
        selectorPrice: ".card-information .price",
        selectorQuickviewBtn: ".quick-add__submit",
        selectorSearchBar: "predictive-search.search-modal__form",
    },
    product: {
        selectorForm: ".section-product-page .product__info-container .product__info-padded-main",
        selectorPrice: ".price",
    },
    miniCart: {
        selectorCard: ".cart-drawer .cart-item",
        selectorOriginPrice: ":not(*)",
        selectorFinalLinePrice: ".cart-item__price-wrapper",
        selectorSubtotalPrice: ".cart-drawer__footer .totals__total-value",
    },
    cart: {
        selectorCard: "#main-cart-items .cart-item",
        selectorOriginPrice: ".product-option--price",
        selectorFinalLinePrice: ".cart-item__price-wrapper",
        selectorSubtotalPrice: ".cart__footer .totals__total-value",
    },
    quickView: {
        selectorCard: ".quick-add-modal .product__info-container .product__info-padded-main",
        selectorPrice: ".price",
    },
    searchBar: {
        selectorCard: ".predictive-search__list-item",
        selectorPrice: ".price",
    }
},coreJS: () => {

},},"Savor":{selector:{
    collection: {
        selectorCard: ".product-grid .product-grid__item",
        selectorPrice: '[ref="priceContainer"]',
        selectorQuickviewBtn: ".quick-add__button.quick-add__button--choose",
        selectorSearchBar: "#predictive-search-results",
    },
    product: {
        selectorForm: ".product-details",
        selectorPrice: '[ref="priceContainer"]',
    },
    miniCart: {
        selectorCard: ".cart-drawer tbody tr",
        selectorOriginPrice: ".cart-items__details > div:first-of-type",
        selectorFinalLinePrice: "text-component",
        selectorSubtotalPrice: ".cart__total-value",
    },
    cart: {
        selectorCard: ".cart-page tbody tr",
        selectorOriginPrice: ".cart-items__details > div:first-of-type",
        selectorFinalLinePrice: "text-component",
        selectorSubtotalPrice: ".cart__total-value",
    },
    quickView: {
        qvSelector: "#quick-add-dialog",
        selectorCard: "#quick-add-modal-content",
        selectorPrice: '[ref="priceContainer"]',
    },
    searchBar: { 
        selectorCard: ".predictive-search-results__card",
        selectorPrice: '[ref="priceContainer"]',
    }
},coreJS: () => {if (BSS_B2B.page.isCartPage()) {
    // if (document.querySelector('.cart-page .cart__total-value span')) {
    //     document.querySelector('.cart-page .additional-checkout-buttons')?.remove();
    // }
    document.querySelector('.additional-checkout-buttons')?.remove();
}

const cartBtn = document.querySelector('.cart-drawer .header-actions__action');
if (!cartBtn) return;
cartBtn.addEventListener('click', () => {
    document.dispatchEvent(new Event('bss_b2b:CustomCartUpdate'));
    document.querySelector('.additional-checkout-buttons')?.remove();
});;const style = document.createElement("style"); style.innerHTML = `[ref="priceContainer"], .cart-items__details > div:first-of-type, text-component, .cart__total-value {
    visibility: hidden;
}

[ref="priceContainer"] span, .cart-items__details > div:first-of-type span, text-component span, .cart__total-value span {
    font-size: inherit !important;
    color: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
}

.cart-items__table-row {
    --cart-item-price-width: initial;
}

.additional-checkout-buttons {
    display: none;
}`;document.head.appendChild(style);},},"Reformation":{selector:{
    collection: {
        selectorCard: "product-card, lb-upsell-flat-card",
        selectorPrice: ".price, .lb-default-price",
        selectorQuickviewBtn: "quick-view"
    },
    product: {
        selectorForm: ".product-information",
        selectorPrice: '.price',
    },
    miniCart: {
        selectorCard: null,
        selectorOriginPrice: null,
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: null,
    },
    cart: {
        selectorCard: "[id^='CartItem']",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".product-subtotal",
        selectorSubtotalPrice: null
    },
    quickView: {
        selectorCard: "#quick-buy-modal-content",
        selectorPrice: ".price-list"
    }
},},"Pallap":{selector:{
    collection: {
        selectorCard: ".product-card-wrapper",
        selectorPrice: ".card-information .price",
        selectorQuickviewBtn: ".card__cart-icon-submit",
        selectorSearchBar: "#Search-In-Modal"
    },
    product: {
        selectorForm: ".product__info-wrapper",
        selectorPrice: ".product-price .price",
    },
    miniCart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart-item__details>div.product-option",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".totals__total-value",
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart-item__details>div.product-option",
        selectorFinalLinePrice: ".cart-item__totals .cart-item__price-wrapper",
        selectorSubtotalPrice: ".totals__total-value, .cart-totals span.font-medium",
    },
    quickView: {
        selectorCard: ".quick-add-modal__content-info",
        selectorPrice: '.price' 
    },
},},"Cornerstone":{selector:{
    collection: {
        selectorCard: ".product-item",
        selectorPrice: ".product-item__text_group_primary .product-item__price-wrap",
        selectorQuickviewBtn: ".product-item__quick-add-beneath .product-item__quick-add",
        selectorSearchBar: ".quick-search__results-wrapper",
    },
    product: {
        selectorForm: ".product__details",
        selectorPrice: ".product__price",
    },
    miniCart: {
        selectorCard: ".quick-cart__item",
        selectorOriginPrice: ".quick-cart__item-price-wrapper",
        selectorFinalLinePrice: ":not(*)",
        selectorSubtotalPrice: ".quick-cart__footer-subtotal .ff-product-price",
    },
    cart: {
        selectorCard: ".cart__form-item",
        selectorOriginPrice: ".cart__form-item-price-wrapper",
        selectorFinalLinePrice: ":not(*)",
        selectorSubtotalPrice: ".cart__footer-subtotal .ff-product-price",
    },
    quickView: {
        qvSelector: ".quick-product-modal",
        selectorCard: ".quick-product",
        selectorPrice: ".product__price-and-ratings .product__price",
    },
    searchBar: {
        selectorCard: ".quick-search__resource-list--columns .quick-search__resource-list-item", 
        selectorPrice: ".ff-product-price",
    }
},coreJS: () => {if (BSS_B2B.page.isProductPage()) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref === location.href) return;
        oldHref = location.href;
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
            productForm
        });
    }).observe(document, {
        subtree: true,
        childList: true,
    });
}

new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === "class"
    ) {
      const hasClass = document.body.classList.contains("confirmation-popup-open");
      if (hasClass) {
        window.dispatchEvent(new Event('scroll')); 
      }
    }
  }
}).observe(document.body, {
  attributes: true,
  attributeFilter: ['class']
});

const qv = document.querySelector(".quick-product-modal");
if (!qv) return;
let qvActive;
new MutationObserver(() => {
    if (!qvActive && qv.classList.contains('active')) {
        qvActive = setTimeout(() => {
            console.log('init qv');
            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
            setTimeout(() => {
                const selectEl = qv.querySelector('select.dynamic-variant-input');
                const productForm = qv.querySelector('[bss-b2b-quickview-product-form]');
                if (!productForm || !selectEl) return;
                selectEl.addEventListener('change', () => {
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                        productForm
                    });
                });
                qvActive = null;
            }, 100);
        }, 2000);
    }
}).observe(qv, { attributes: true, attributeFilter: ['class'] });
;const style = document.createElement("style"); style.innerHTML = `.product-item__price-wrap, .product__price, .quick-cart__item-price-wrapper, .quick-cart__item .ff-product-price, .cart__form-item .ff-product-price, .quick-search__resource-list--columns .ff-product-price {
    visibility: hidden;
}

.bss-b2b-price-no-vat {
    margin-right: 8px;
}
`;document.head.appendChild(style);},},"Local":{anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.drawer__footer-buttons',
            checkoutSelector: 'form button[name="checkout"]'
        },
        cartPage: {
            position: 'afterEnd',
            selector: 'button[name="checkout"]',
            checkoutSelector: 'button[name="checkout"]'
        }
    },
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: '#AjaxCartSubtotal'
        },
        cartPage: {
            position: 'afterBegin',
            selector: '.cart__details.cart__subtotal-widget'
        } 
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer-bottom'
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button[name="checkout"]'
        }
    }
},},"Kalles":{selector:{
    collection: {
        selectorCard: ".ecom-collection__product-item, .hdt-minicart-recommendations__item",
        selectorPrice: ".ecom-collection__product-price, .hdt-price",
        selectorQuickviewBtn: ":not(*)",
        selectorSearchBar: ":not(*)",
    },
    product: {
        selectorForm: "#ecom-tpl-prodotto-2 form:first-of-type",
        selectorPrice: ".ecom-product-single__price-wrapper",
    },
    miniCart: {
        selectorCard: "hdt-line-item",
        selectorOriginPrice: ".hdt-price",
        selectorFinalLinePrice: ":not(*)",
        selectorSubtotalPrice: ".hdt-totals__total-value",
    },
    cart: {
        selectorCard: ".hdt-page-cart__item",
        selectorOriginPrice: ".hdt-cart-item__price .hdt-price",
        selectorFinalLinePrice: ".hdt-cart-item__total .hdt-price",
        selectorSubtotalPrice: ".hdt-totals__total-value",
    },
    quickView: {
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    },
    searchBar: {
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    }
},anchor:{
    netterm: {
        miniCart: {
            position: 'afterEnd',
            selector: '.drawer__footer-buttons',
            checkoutSelector: 'form button[name="checkout"]',
        },
        cartPage: {
            position: 'afterEnd',
            selector: 'button[name="checkout"]',
            checkoutSelector: 'button[name="checkout"]',
        }
    },
    taxExempt: {
        miniCart: {
            position: 'beforeBegin',
            selector: 'button.bss-checkout',
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button.bss-checkout',
        }
    },
    discountCodes: {
        miniCart: {
            position: 'beforeBegin',
            selector: '.drawer__footer-bottom',
        },
        cartPage: {
            position: 'beforeBegin',
            selector: 'button[name="checkout"]',
        }
    }
},coreJS: () => {const getCurrVariant = (curVariantId) => {
    if (curVariantId) return curVariantId;
    const input = document.querySelector('form[action="/cart/add"] input[type="hidden"][name="id"]');
    return +input?.value ?? curVariantId;
};
BSS_B2B.custom.addFilter('detect:product_variant', getCurrVariant);

const getQbTablePosition = (cartFormEl) => {
    return cartFormEl ?? document.querySelector('.ecom-block.ecom-7x06sewhm1');
};
BSS_B2B.custom.addFilter('custom:qb_table_position/under_product_price', getQbTablePosition);

if (!BSS_B2B.page.isCartPage()) {
    const cartBtn = document.querySelector('.hdt-site-nav_cart');
    cartBtn?.addEventListener('click', () => window.dispatchEvent(new Event('scroll')));
};const style = document.createElement("style"); style.innerHTML = `#ecom-tpl-prodotto-2 .ecom-product-single__price-wrapper {
    font-size: 42px;
    line-height: 1.4em;
    font-weight: 400;
    text-transform: none;
    font-style: normal;
    text-decoration: none;
    letter-spacing: 0px;
    font-family: Roboto, sans-serif;
    color: #000;
}

.ecom-collection__product-price, .ecom-product-single__price-wrapper, .hdt-price, .hdt-totals__total-value {
    visibility: hidden;
}

.ecom-collection__product-price span, .ecom-product-single__price-wrapper span, .hdt-price span, .hdt-totals__total-value span {
    color: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
    font-weight: inherit !important;
    font-family: inherit !important;
}

#ecom-tpl-prodotto-2 form:first-of-type:not(:has(bss-b2b-price-has-vat)) .bss-b2b-cart-item-qty-table .bss-b2b-price-has-vat {
    display: none;
}`;document.head.appendChild(style);},},"Sleek":{selector:{
    collection: {
        selectorCard: ".EnEINgcedyLwhYJ5R243 a",
        selectorPrice: ".T8Sgy27uJ3d_Vxh_YYJV",
        selectorQuickviewBtn: ".product-card__quick-buy button"
    },
    product: {
        selectorForm: ".product__info-container",
        selectorPrice: '.product__block--price',
    },
    miniCart: {
        selectorCard: "[id^='CartDrawer-Item']",
        selectorOriginPrice: ".price.font-body-bolder",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: "[data-hulkapps-cart-total]",
    },
    cart: {
        selectorCard: "[id^='CartItem']",
        selectorOriginPrice: '.cart-item__prices',
        selectorFinalLinePrice: ".total-price-item",
        selectorSubtotalPrice: "[data-hulkapps-cart-total]"
    },
    quickView: {
        selectorCard: "#quick-buy-modal-content",
        selectorPrice: ".price-list"
    }
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.product__block--price:has(span+span)>span {
    font-size: 3.2rem !important;
    line-height: 4.2rem !important;
    font-weight: 600 !important;
}`;document.head.appendChild(style);},},"Glozin":{selector:{
    collection: {
        selectorCard: ".product-item",
        selectorPrice: ".card-product-price",
        selectorQuickviewBtn: ":not(*)",
        selectorSearchBar: "#predictive-search"
    },
    product: {
        selectorForm: "skeleton-page:has(.product-detail__information)",
        selectorPrice: ".card-product-price",
    },
    miniCart: {
        selectorCard: "#minicart .items > div",
        selectorOriginPrice: ".minicart__item-price",
        selectorFinalLinePrice: ":not(*)",
        selectorSubtotalPrice: ".subtotal-price",
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart__page-price .cart-item__price-wrapper",
        selectorFinalLinePrice: ".cart-item__totals .cart-item__price-wrapper",
        selectorSubtotalPrice: ".totals .price",
    },
    quickView: {
        selectorCard: ":not(*)",
        selectorPrice: ":not(*)",
    },
    searchBar: {
        selectorCard: ".search-results-list .product-item",
        selectorPrice: ".card-product-price",
    }
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `.card-product-price, .minicart__item-price, .subtotal-price, .cart-item__price-wrapper, .totals .price {
    visibility: hidden;
}

.product-detail__information .card-product-price > span {
    font-family: var(--heading-font);
    font-weight: var(--heading-weight, 600);
    color: var(--color-heading) !important;
    font-size: clamp(2.4rem, 3vw, 2.6rem);
}

.product-item .card-product-price > span, .search-results-list .product-item > span {
    font-family: var(--heading-font);
    font-weight: var(--heading-weight, 600);
    color: var(--color-heading) !important;
    font-size: 15px;
}

#minicart .minicart__item-original-price {
    display: none;
}`;document.head.appendChild(style);},},"Emerge":{selector:{
    collection: {
        selectorCard: ".product-card--root",
        selectorPrice: ".product--price",
        selectorQuickviewBtn: null
    },
    product: {
        selectorForm: ".product-form",
        selectorPrice: 'product-price-element',
    },
    miniCart: {
        selectorCard: ".easc-productRow",
        selectorOriginPrice: ".easc-prodRowPrice",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: ".easc-subtotalDiscIcon span:nth-child(2)",
    },
    cart: {
        selectorCard: ".cart--item",
        selectorOriginPrice: ".cart--item--price .money",
        selectorFinalLinePrice: ".cart--item--total .money",
        selectorSubtotalPrice: ".cart--total-price"
    },
    quickView: {
        selectorCard: null,
        selectorPrice: null
    }
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `product-price-element:has(span+span) > span{
    font-size: 32px !important;
    font-weight: 700;
}`;document.head.appendChild(style);},},"KARITALE by WEEBY":{selector:{
    collection: {
        selectorCard: ".product-card, .product-cross-sell",
        selectorPrice: ".price-list",
        selectorQuickviewBtn: ".product-card__quick-buy .button[aria-controls*='product-quick-buy']",
        selectorSearchBar: "#predictive-search",
    },
    product: {
        selectorForm: ".product .product-info__block-list",
        selectorPrice: "[data-block-id='price'] .price-list",
    },
    miniCart: {
        selectorCard: "#cart-drawer .line-item",
        selectorOriginPrice: ":not(*)",
        selectorFinalLinePrice: ".line-item__line-price",
        selectorSubtotalPrice: ".cart-drawer__total",
    },
    cart: {
        selectorCard: ".cart .order-summary__body tr",
        selectorOriginPrice: ":not(*)",
        selectorFinalLinePrice: "td:last-child div:first-child",
        selectorSubtotalPrice: ".cart__right .h-stack:first-child span:last-child",
    },
    quickView: {
        selectorCard: "#quick-buy-modal-content .quick-buy__info",
        selectorPrice: ".price-list",
    },
    searchBar: {
        selectorCard: ".product-card",
        selectorPrice: ".price-list",
    }
},coreJS: () => {},},"Whisk":{selector:{
    collection: {
        selectorCard: ".product-card__content",
        selectorPrice: "product-price .price",
        selectorQuickviewBtn: ".button.quick-add__button",
        selectorSearchBar: ".predictive-search-dropdown"
    },
    product: {
        selectorForm: ".featured-product__info-container",
        selectorPrice: ".product-price",
    },
    miniCart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart__price",
        selectorFinalLinePrice: ".cart-item__price.cart-item__subtotal",
        selectorSubtotalPrice: null,
    },
    cart: {
        selectorCard: ".cart-item",
        selectorOriginPrice: ".cart__price",
        selectorFinalLinePrice: ".cart-item__price.cart-item__subtotal",
        selectorSubtotalPrice: ".cart__total-value",
    },
    quickView: {
        selectorCard: ".quick-add-modal__content",
        selectorPrice: 'product-price [ref="priceContainer"]' 
    },
    searchBar: { 
        selectorCard: '.predictive-search-results__card', 
        selectorPrice: '[ref="priceContainer"]'
    }
},},"Selene":{selector:{
    collection: {
        selectorCard: ".product-card--root",
        selectorPrice: ".product--price-wrapper",
        selectorQuickviewBtn: null,
        selectorSearchBar: null,
    },
    product: {
        selectorForm: ".product-form",
        selectorPrice: "product-price-element",
    },
    miniCart: {
        selectorCard: ".easc-productRow",
        selectorOriginPrice: ".d-flex-desktop.ea-normalLineHeight.easc-align-center.mt-1.mb-1",
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: "span.d-flex.easc-subtotalDiscIcon",
    },
    cart: {
        selectorCard: ".cart--item",
        selectorOriginPrice: ".cart--item--price .money",
        selectorFinalLinePrice: ".cart--item--total .money",
        selectorSubtotalPrice: ".cart--total-price",
    },
    quickView: {
        selectorCard: null,
        selectorPrice: null,
    },
    searchBar: {
        selectorCard: null,
        selectorPrice: null,
    }
},coreJS: () => {document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `#search_input`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); ;const style = document.createElement("style"); style.innerHTML = `product-price-element {
    font-size: 32px !important;
    font-weight: 700;
}`;document.head.appendChild(style);},},"Focal":{selector:{
    collection: {
        selectorCard: "gp-product",
        selectorPrice: ".gp-row",
        selectorQuickviewBtn: null,
        selectorSearchBar: null
    },
    product: {
        selectorForm: "[data-same-height-display-contents]",
        selectorPrice: ".gp-price",
    },
    miniCart: {
        selectorCard: null,
        selectorOriginPrice: null,
        selectorFinalLinePrice: null,
        selectorSubtotalPrice: null,
    },
    cart: {
        selectorCard: ".line-item",
        selectorOriginPrice: ".price-list .money",
        selectorFinalLinePrice: ".price-list.price-list--stack",
        selectorSubtotalPrice: "..cart__total-container .money",
    },
    quickView: {
        selectorCard: null,
        selectorPrice: null
    },
},coreJS: () => {const style = document.createElement("style"); style.innerHTML = `gp-row:has(span+span) > span {
    
}`;document.head.appendChild(style);},},};window.KC.page = {};
    
    // Chờ đợi các biến cần thiết từ code core để check xem DC box có được show hay không
    window.KC.waitForExist = (pathGetter, callback, timeout = 6446, interval = 100) => {
        const start = Date.now();
        const timer = setInterval(() => {
            let exists = false;
            try {
                const value = pathGetter();
                exists = value !== undefined && value !== null;
            } catch (e) { }
            if (exists) {
                clearInterval(timer);
                callback();
            } else if (Date.now() - start > timeout) {
                clearInterval(timer);
            }
        }, interval);
    }
    
    // Lặp qua từng thành phần trong selector, trả về phần tử đầu tiên tìm thấy
    window.KC.findFirstMatchingElement = (selectorsString) => {
        const selectors = selectorsString.split(',').map(s => s.trim());
        for (const selector of selectors) {
            const element = document.querySelector(selector);
            if (element) return element;
        }
        return null;
    }
    
    window.KC.debounce = function (func, wait = 300) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    };
    
    window.KC.copyStyles = function (source, target) {
        const computed = window.getComputedStyle(source);
        for (let i = 0; i < computed.length; i++) {
            const prop = computed[i];
            if (['display', 'visibility'].includes(prop)) continue;
            const value = computed.getPropertyValue(prop);
            target.style.setProperty(prop, value, computed.getPropertyPriority(prop));
        }
    
        const pseudoList = ['::before', '::after'];
        pseudoList.forEach(pseudo => {
            const pseudoStyles = window.getComputedStyle(source, pseudo);
            const content = pseudoStyles.getPropertyValue('content');
    
            if (content && content !== 'none') {
                const css = Array.from(pseudoStyles)
                    .map(prop => `${prop}: ${pseudoStyles.getPropertyValue(prop)};`)
                    .join(' ');
    
                const style = document.createElement('style');
                style.textContent = `
            #${target.id}${pseudo} {
                ${css}
            }
            `;
                document.head.appendChild(style);
            }
        });
    }
    
    window.KC.observe = function observeElementChange(selector, options, callback, once = false) {
        const target = document.querySelector(selector);
        if (!target) {
            console.warn(`KC Solutions: Không tìm thấy phần tử: ${selector}`);
            return null;
        }
    
        const observer = new MutationObserver((mutationsList, observerInstance) => {
            for (const mutation of mutationsList) {
                if (options.type === 'class' && mutation.attributeName === 'class') {
                    callback(target.classList);
                }
                else if (options.type === 'attribute' && mutation.attributeName === options.attributeName) {
                    callback(target.getAttribute(options.attributeName));
                }
                else if (options.type === 'childList' && mutation.type === 'childList') {
                    callback(mutation);
                }
                else if (options.type === 'all') {
                    callback(mutation);
                }
    
                if (once) {
                    observerInstance.disconnect();
                }
            }
        });
    
        observer.observe(target, {
            attributes: true,
            childList: options.type === 'childList' || options.type === 'all',
            subtree: options.subtree || false,
            attributeFilter: options.type === 'attribute' ? [options.attributeName] : undefined,
        });
    
        return observer;
    }
    
    window.KC.page.getPage = function () {
        let hrefArr = window.location.href.split('/');
        return hrefArr;
    };
    
    window.KC.page.isCartPage = function () {
        let hrefArr = window.KC.page.getPage();
        let isCart = (hrefArr[hrefArr.length - 1] === 'cart' ||
            (hrefArr[hrefArr.length - 1].includes('cart') && hrefArr[hrefArr.length - 2] !== 'products') &&
            hrefArr[hrefArr.length - 2] !== 'collections');
        return isCart;
    };
    
    window.KC.page.isCollectionPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
            return window.ShopifyAnalytics.meta.page.pageType === 'collection';
        }
        else {
            let hrefArr = window.KC.page.getPage();
            let isCollectionPage = hrefArr[hrefArr.length - 2] === 'collections';
            return isCollectionPage;
        }
    };
    
    window.KC.page.isSearchPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            window.ShopifyAnalytics.meta.page.pageType) {
            return window.ShopifyAnalytics.meta.page.pageType === 'searchresults';
        }
        else {
            let hrefArr = window.KC.page.getPage();
            let isSearchPage = hrefArr[hrefArr.length - 1] === 'search' ||
                hrefArr[hrefArr.length - 1].includes('search');
            return isSearchPage;
        }
    };
    
    window.KC.page.isLoginPage = function () {
        let hrefArr = window.KC.page.getPage();
        let isLoginPage = (hrefArr[hrefArr.length - 1] === 'login' || hrefArr[hrefArr.length - 1].includes('login')) &&
            hrefArr[hrefArr.length - 2] === 'account';
        return isLoginPage;
    };
    
    window.KC.page.isRegisterPage = function () {
        let hrefArr = window.KC.page.getPage();
        let isRegisterPage = (hrefArr[hrefArr.length - 1] === 'register' ||
            hrefArr[hrefArr.length - 1].includes('register')) && hrefArr[hrefArr.length - 2] === 'account';
        return isRegisterPage;
    };
    
    window.KC.page.isProductPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
            return window.ShopifyAnalytics.meta.page.pageType === 'product';
        }
        else {
            let hrefArr = window.KC.page.getPage();
            let isProductPage = hrefArr[hrefArr.length - 2] === 'products';
            return isProductPage;
        }
    };
    
    window.KC.page.isQuickOrderPage = function () {
        let hrefArr = window.KC.page.getPage();
        let isQuickOrderPage = (hrefArr[hrefArr.length - 1] === 'quick-order' && hrefArr[hrefArr.length - 2] !==
            'customer-portal');
        return isQuickOrderPage;
    };
    
    window.KC.page.isCustomPage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            window.ShopifyAnalytics.meta.page.pageType) {
            return window.ShopifyAnalytics.meta.page.pageType === 'page';
        }
        else {
            let hrefArr = window.KC.page.getPage();
            let isCustomPage = (hrefArr[hrefArr.length - 2] === 'pages');
            return isCustomPage;
        }
    };
    
    window.KC.page.isHomePage = function () {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page &&
            window.ShopifyAnalytics.meta.page.pageType) {
            return window.ShopifyAnalytics.meta.page.pageType === 'home';
        }
        else {
            let hrefArr = window.KC.page.getPage();
            let isHomePage = (hrefArr[hrefArr.length - 1] === '');
            return isHomePage;
        }
    };
    
    window.KC.renderTE = function () {
        if (!BSS_B2B?.te?.status) return;
        // Ẩn các teBox không phải được tạo ra từ KC Solution, mà được tạo manual hoặc app block
        const styleHiddenTEAppBlock = document.createElement("style");
        styleHiddenTEAppBlock.id = 'styleHiddenTEAppBlock';
        styleHiddenTEAppBlock.textContent = `
                .bss-b2b-tax-ex-wrapper:not(.kc-te-box) {
                    display: none !important;
                }
            `;
        document.head.appendChild(styleHiddenTEAppBlock);
    
        if (typeof window.KC.waitForExist === 'function') {
            window.KC.waitForExist(
                () => BSS_B2B?.shopData?.customer,
                () => {
                    setTimeout(() => {
                        handleAddTEBox();
                    }, 2000)
                    handleAddTEBox();
                },
                5000
            );
        } else {
            console.log('window.KC.waitForExist not a function');
        }
    
        function handleAddTEBox() {
            try {
                const vatSelected = BSS_B2B.te.vatExemptSelected;
                let isShowVATForm = false;
                let customerTags;
                if (BSS_B2B.shopData.customer.id) {
                    customerTags = BSS_B2B.shopData.customer.tags.map(tag => tag.toLowerCase())
                } else {
                    customerTags = [];
                }
                const isLoggedIn = BSS_B2B.shopData.customer.id;
                const teTags = BSS_B2B.te.vatSetting.show_vat_customer_tags.toLowerCase().split(',');
                const {
                    enable_eu_vat,
                    enable_uk_vat,
                    enable_gst,
                    enable_us_ein,
                    enable_abn,
                    show_vat_apply_to,
                    show_vat_customer_ids
                } = BSS_B2B.te.vatSetting;
    
                const show_vat_cart = 1; // Đoạn này không public ra biến, đặt tạm biến này là true, sau này báo bên feature
    
                if (enable_eu_vat == "1" || enable_uk_vat == "1" || enable_gst == "1" || enable_us_ein == "1" || enable_abn == "1") {
                    if (show_vat_cart == "1") {
                        if (show_vat_apply_to == "0") {
                            isShowVATForm = true;
                        } else if (show_vat_apply_to == "1") {
                            if (isLoggedIn) {
                                isShowVATForm = true;
                            }
                        } else if (show_vat_apply_to == "2") {
                            if (!isLoggedIn) {
                                isShowVATForm = true;
                            }
                        } else if (show_vat_apply_to == "3") {
                            for (let tag of teTags) {
                                if (customerTags.includes(tag)) {
                                    isShowVATForm = true;
                                    break;
                                }
                            }
                        } else if (show_vat_apply_to == "4") {
                            if (BSS_B2B.shopData.customer) {
                                const customerIdString = String(BSS_B2B.shopData.customer.id);
                                const customerIdsString = show_vat_customer_ids.join(',');
                                if (customerIdsString.includes(customerIdString)) {
                                    isShowVATForm = true;
                                }
                            }
                        }
                    }
                }
    
                // Nếu được áp dụng rule mới tiến hành show TE
                if (isShowVATForm) {
                    const {
                        form_header_text,
                        form_header_text_abn,
                        form_header_text_gst,
                        form_header_text_uk,
                        form_header_text_us_ein,
                        form_subtitle_text,
                        form_subtitle_text_abn,
                        form_subtitle_text_gst,
                        form_subtitle_text_uk,
                        form_subtitle_text_us_ein,
                        form_success_message,
                        form_success_message_uk,
                        form_success_message_abn,
                        form_success_message_gst,
                        form_success_message_us_ein,
                        form_error_message,
                        form_error_message_uk,
                        form_error_message_abn,
                        form_error_message_gst,
                        form_error_message_us_ein,
                        form_validate_country_code_message
                    } = BSS_B2B.te.teTranslations;
    
                    const teHTML = `<div class="bss-b2b-tax-ex-wrapper bss-config-header kc-te-box" show-wrapper="0">
                    <h3 class="bss-vat-exempt-form-header-text">
                        <span class="bss-b2b-translation-vat-form_header_text">${form_header_text}</span>
                        <span class="bss-b2b-translation-vat-form_header_text_uk">${form_header_text_uk}</span>
                        <span class="bss-b2b-translation-vat-form_header_text_abn">${form_header_text_abn}</span>
                        <span class="bss-b2b-translation-vat-form_header_text_gst">${form_header_text_gst}</span>
                        <span class="bss-b2b-translation-vat-form_header_text_us_ein">${form_header_text_us_ein}</span>
                    </h3>
                    <p class="bss-vat-exempt-form-subtitle-text">
                        <span class="bss-b2b-translation-vat-form_subtitle_text">${form_subtitle_text}</span>
                        <span class="bss-b2b-translation-vat-form_subtitle_text_uk">${form_subtitle_text_uk}</span>
                        <span class="bss-b2b-translation-vat-form_subtitle_text_abn">${form_subtitle_text_abn}</span>
                        <span class="bss-b2b-translation-vat-form_subtitle_text_gst">${form_subtitle_text_gst}</span>
                        <span class="bss-b2b-translation-vat-form_subtitle_text_us_ein">${form_subtitle_text_us_ein}</span>
                    </p>
                    <div class="bss-b2b-vat-input-wrapper">
                        <select name="bss-b2b-vat-selected" class="bss-b2b-vat-selected">
                            <option value="0">EU</option> 
                            <option value="1">UK</option> 
                            <option value="2">ABN</option>
                        </select>
                        <input type="text" name="bss-b2b-eu-tax" class="bss-b2b-vat-input">
                    </div>
                    <div class="bss-b2b-tax-ex-message">
                        <p class="bss-b2b-tax-invalid">
                        <span class="tax-icon-error">✕</span>
                        <span class="tax-message tax-error-message">
                            <span class="bss-b2b-translation-vat-form_error_message">${form_error_message}</span>
                            <span class="bss-b2b-translation-vat-form_error_message_uk">${form_error_message_uk}</span>
                            <span class="bss-b2b-translation-vat-form_error_message_abn">${form_error_message_abn}</span>
                            <span class="bss-b2b-translation-vat-form_error_message_gst">${form_error_message_gst}</span>
                            <span class="bss-b2b-translation-vat-form_error_message_us_ein">${form_error_message_us_ein}</span>
                            <span class="bss-b2b-translation-vat-form_validate_country_code_message">${form_validate_country_code_message}</span>
                        </span>
                        </p>
                        <p class="bss-b2b-tax-valid">
                        <span class="tax-icon-success">✓</span>
                        <span class="tax-message tax-success-message">
                            <span class="bss-b2b-translation-vat-form_success_message">${form_success_message}</span>
                            <span class="bss-b2b-translation-vat-form_success_message_uk">${form_success_message_uk}</span>
                            <span class="bss-b2b-translation-vat-form_success_message_abn">${form_success_message_abn}</span>
                            <span class="bss-b2b-translation-vat-form_success_message_gst">${form_success_message_gst}</span>
                            <span class="bss-b2b-translation-vat-form_success_message_us_ein">${form_success_message_us_ein}</span>
                        </span>
                        </p>
                    </div>
                    </div>`;
    
                    addVATStyles();
    
                    const selectorElementAnchorCartPage = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.taxExempt?.cartPage?.selector || '[name="checkout"]';
                    const selectorElementAnchorCartSlider = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.taxExempt?.miniCart?.selector || '[name="checkout"]';
                    let position = null;
                    let elementAnchor = null;
    
                    const interval = setInterval(() => {
                        if (window.KC.page.isCartPage()) {
                            elementAnchor = document.querySelector(selectorElementAnchorCartPage);
                            position = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.taxExempt?.cartPage?.position || 'beforeBegin';
                        } else {
                            elementAnchor = document.querySelector(selectorElementAnchorCartSlider);
                            position = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.taxExempt?.miniCart?.position || 'beforeBegin';
                        }
    
                        if (elementAnchor && !elementAnchor?.parentNode?.querySelector?.(".bss-b2b-tax-ex-wrapper")) {
                            document.querySelectorAll(".bss-b2b-tax-ex-wrapper:not(.kc-te-box)").forEach(item => item.remove());
                            document.querySelector('#styleHiddenTEAppBlock')?.remove();
                            elementAnchor.insertAdjacentHTML(position, teHTML);
                            addEventLoadingCheckout();
                            document.addEventListener("KC:cloneCheckoutDone", addEventLoadingCheckout, { once: true });
                            addEventTE();
                            clearInterval(interval);
                        }
                    }, 100);
    
                    setTimeout(() => {
                        clearInterval(interval);
                    }, 5000);
                }
            } catch (e) {
                console.log(e)
            }
        }
    
        function addEventLoadingCheckout() {
            // add loading khi check TE BOX
            const checkoutElements = document.querySelectorAll(".bss-checkout, [name='checkout']");
            checkoutElements.forEach(checkout => checkout.addEventListener("click", e => {
                setCheckoutBtnLoading(true, checkoutElements);
            }, true));
            // lắng nghe khi check VAT xong thì tắt loading
            const targetNode = document.querySelector('.bss-b2b-tax-ex-wrapper');
            if (targetNode) {
                const config = { attributes: true };
                const callback = () => {
                    const checkoutElements = document.querySelectorAll(".bss-checkout");
                    setCheckoutBtnLoading(false, checkoutElements);
                };
                const observer = new MutationObserver(callback);
                observer.observe(targetNode, config);
            }
        }
    
        function addVATStyles() {
            const style = document.createElement("style");
            style.textContent = `
                .bss-b2b-vat-selected {
                    border-radius: 8px 0 0 8px;
                    padding: 12px 10px;
                    border: 1px solid #e6e6e6;
                }
                .bss-b2b-vat-input {
                    border-radius: 0 8px 8px 0;
                    border: 1px solid #e6e6e6;
                    transform: translateX(-1px);
                    padding: 12px 10px;
                }
                .bss-b2b-tax-invalid {      
                    color: #FF0000;
                } 
                .bss-b2b-tax-valid {
                    color:#00FF00;
                }
                .tax-icon-error {
                    color: #FF0000;
                    border: 1px #FF0000 solid;
                    display:none;
                }
                .tax-icon-success {
                    color:#00FF00; 
                    border: 1px#00FF00 solid;
                    display:none;
                }
    
                .bss-b2b-translation-vat-form_header_text {
                    color:#000;
                }
    
                .bss-config-header {
                    display: none;
                }
    
                .tax-icon-error,
                .tax-icon-success {
                    display: none;
                    font-size: 20px;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    padding: 0 4px;
                }
    
                .bss-b2b-tax-invalid,
                .bss-b2b-tax-valid {
                    margin-top: 5px;
                }
                .ajaxcart__footer {
                    height: 420px !important;
                }
    
                .tax-icon-error,
                .tax-icon-success {
                    display: none;
                    font-size: 20px;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    padding: 0 4px;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    padding: 0 4px;
                }
    
                .bss-b2b-tax-invalid,
                .bss-b2b-tax-valid {
                    margin-top: 5px;
                }
    
                .bss-b2b-tax-ex-wrapper .bss-vat-exempt-form-header-text > span,
                .bss-b2b-tax-ex-wrapper .bss-vat-exempt-form-subtitle-text > span,
                .bss-b2b-tax-ex-wrapper .tax-error-message > span,
                .bss-b2b-tax-ex-wrapper .tax-success-message > span,
                .bss-b2b-translation-vat-form_validate_country_code_message,
                .tax-icon-error,
                .tax-icon-success,
                .tax-icon-validate_country_code {
                    display: none;
                }
    
                [show-wrapper="0"] .bss-b2b-translation-vat-form_header_text,
                [show-wrapper="1"] .bss-b2b-translation-vat-form_header_text_uk,
                [show-wrapper="2"] .bss-b2b-translation-vat-form_header_text_abn,
                [show-wrapper="3"] .bss-b2b-translation-vat-form_header_text_gst,
                [show-wrapper="4"] .bss-b2b-translation-vat-form_header_text_us_ein,
                [show-wrapper="0"] .bss-b2b-translation-vat-form_subtitle_text,
                [show-wrapper="1"] .bss-b2b-translation-vat-form_subtitle_text_uk,
                [show-wrapper="2"] .bss-b2b-translation-vat-form_subtitle_text_abn,
                [show-wrapper="3"] .bss-b2b-translation-vat-form_subtitle_text_gst,
                [show-wrapper="4"] .bss-b2b-translation-vat-form_subtitle_text_us_ein,
                [show-message="ERR_0"] .bss-b2b-translation-vat-form_error_message,
                [show-message="ERR_1"] .bss-b2b-translation-vat-form_error_message_uk,
                [show-message="ERR_2"] .bss-b2b-translation-vat-form_error_message_abn,
                [show-message="ERR_3"] .bss-b2b-translation-vat-form_error_message_gst,
                [show-message="ERR_4"] .bss-b2b-translation-vat-form_error_message_us_ein,
                [show-message="VAT_VALIDATECOUNTRY"] .tax-icon-error,
                [show-message="VAT_SUCCESS_0"] .bss-b2b-translation-vat-form_success_message,
                [show-message="VAT_SUCCESS_1"] .bss-b2b-translation-vat-form_success_message_uk,
                [show-message="VAT_SUCCESS_2"] .bss-b2b-translation-vat-form_success_message_abn,
                [show-message="VAT_SUCCESS_3"] .bss-b2b-translation-vat-form_success_message_gst,
                [show-message="VAT_SUCCESS_4"] .bss-b2b-translation-vat-form_success_message_us_ein,
                [show-message="VAT_VALIDATECOUNTRY"] .bss-b2b-translation-vat-form_validate_country_code_message {
                    display: unset !important;
                }
            `;
            document.head.appendChild(style);
        }
    
        function addEventTE() {
            const teSelected = document.querySelector('.bss-b2b-vat-selected');
            const teWrapper = document.querySelector('.bss-b2b-tax-ex-wrapper');
            const teMessage = document.querySelector('.bss-b2b-tax-ex-message');
    
            if (teSelected && teWrapper && teMessage) {
                teSelected.value = String(BSS_B2B.te.vatExemptSelectedOriginal);
    
                teSelected.addEventListener('change', function (e) {
                    teWrapper.removeAttribute('show-message');
    
                    const valueSelected = e.target.value;
                    BSS_B2B.te.vatExemptSelected = valueSelected != null ? parseInt(valueSelected, 10) : 0;
    
                    teWrapper.setAttribute('show-wrapper', String(BSS_B2B.te.vatExemptSelected));
    
                    BSS_B2B.integrate.langShop.translatedModules.vat = false;
                    BSS_B2B.integrate.langShop.handleAllTranslation('vat');
                });
            }
        }
    
        function setCheckoutBtnLoading(status, checkoutElements, checkoutSelector = '', productForm) {
            const loaderAttr = 'bss-b2b-checkout-loader';
            const defaultAttr = 'bss-b2b-default-checkout';
    
            if (status) {
                const bssLoader = `<div style="display: flex;"><div class="bss-loader" style="display: block;"></div></div>`;
                checkoutElements.forEach((checkoutElem) => {
                    if (checkoutElem instanceof HTMLElement) {
                        const checkoutElemLoader = checkoutElem.cloneNode(true);
                        if (checkoutElemLoader instanceof HTMLButtonElement) {
                            checkoutElemLoader.disabled = true;
                        } else {
                            if (checkoutElemLoader?.style) {
                                checkoutElemLoader.style.cursor = 'none';
                            }
                        }
                        checkoutElemLoader.setAttribute(loaderAttr, 'true');
                        checkoutElemLoader.innerHTML = bssLoader;
                        if (checkoutElem?.style) {
                            checkoutElem.style.setProperty('display', 'none', 'important');
                        }
                        checkoutElem.after(checkoutElemLoader);
                        checkoutElem.setAttribute(defaultAttr, 'true');
                    }
                });
            } else {
                document.querySelectorAll(`[${loaderAttr}]`).forEach(el => el.remove());
                let isShow = true;
                if (productForm) {
                    const defaultBIN = productForm.querySelector('[bss-b2b-default-buy-now]');
                    if (defaultBIN && window.getComputedStyle(defaultBIN).display === 'block') {
                        isShow = false;
                    }
                }
                if (isShow) {
                    let el = document.querySelectorAll(`[${defaultAttr}]${checkoutSelector}`);
                    if (el && el.firstChild && el.firstChild.style) {
                        el.firstChild.style.display = 'none';
                    }
                    el = document.querySelectorAll(`.bss-checkout`);
                    try {
                        if (el && el[el.length - 1].style) {
                            el[el.length - 1].style.display = 'block';
                        }
                    } catch (e) { }
                }
            }
        }
    }
    
    window.KC.renderDC = function () {
        if (!BSS_B2B?.dc?.status) return;
        // Ẩn các dcBox không phải được tạo ra từ KC Solution, mà được tạo manual hoặc app block
        const styleHiddenDCAppBlock = document.createElement("style");
        styleHiddenDCAppBlock.id = 'styleHiddenDCAppBlock';
        styleHiddenDCAppBlock.textContent = `
            .bss-b2b-discount-code-wrapper:not(.kc-dc-box) {
                display: none !important;
            }
        `;
        document.head.appendChild(styleHiddenDCAppBlock);
    
        if (typeof window.KC.waitForExist === 'function') {
            window.KC.waitForExist(() => BSS_B2B?.dc?.utils?.cart?.getCustomerAppliedRules,
                () => {
                    handleAddDCBox();
                }, 5000);
        } else {
            console.log('window.KC.waitForExist not a function');
        }
    
        function handleAddDCBox() {
            try {
                const rules = BSS_B2B.dc.utils.cart.getCustomerAppliedRules();
                if (rules?.length === 0) return;
                const {
                    button_apply,
                    form_header_text
                } = BSS_B2B.dc.dcTranslations;
    
                const {
                    layout,
                    input_placeholder,
                    header_font_size,
                    header_color,
                    button_height,
                    button_width,
                    button_border_radius,
                    button_color,
                    button_text_color,
                    input_height,
                    input_width,
                    input_border_width,
                    input_border_color,
                    input_border_style,
                    input_border_radius
                } = BSS_B2B.dc.dcStyles;
    
                const style = document.createElement("style");
                style.id = "styleDCBoxKC"
    
                style.textContent = `
                        .bss-b2b-discount-code-wrapper,
                        .bss-b2b-discount-code-wrapper * {
                            min-width: 100% !important;
                        }
                    
                        .bss-b2b-translation-dc-form_header_text {
                            font-size: ${header_font_size}px;
                            font-style: normal;
                            font-family: inherit !important;
                            font-weight: 600;
                            line-height: 23px;
                            color: ${header_color};
                            margin-bottom: 10px;
                        }
    
                        #bss-b2b-discount-code-submit {
                            margin-top: 0;
                            height: revert-layer !important;
                            width: ${button_width}px;
                            appearance: none;
                            display: inline-block;
                            text-decoration: none;
                            text-align: center;
                            vertical-align: middle;
                            cursor: pointer;
                            border: 1px solid transparent;
                            border-radius: ${button_border_radius}px;
                            padding: 8px 15px;
                            background-color: ${button_color};
                            color: ${button_text_color};
                            letter-spacing: .08em;
                            white-space: normal;
                            font-size: calc(((var(--font-size-base) - 2) / (var(--font-size-base))) * 1em);
                            position: relative;
                        }
    
                        #bss-b2b-discount-code-submit.loading span {
                            visibility: hidden;
                        }
    
                        #bss-b2b-discount-code-submit.loading:after {
                            content: "";
                            display: block;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            width: 20px;
                            height: 20px;
                            margin: -10px 0 0 -10px;
                            border-radius: 50%;
                            border: 2px solid #fff;
                            border-top-color: #000;
                            animation: spin 0.6s linear infinite;
                        }
    
                        .bss-b2b-discount-code-wrapper {
                            margin-bottom: 30px;
                            display: none;
                            width: 300px;
                            text-align: left !important;
                        }
    
                        #bss-b2b-discount-code-input-wrapper {
                            margin-bottom: 10px
                        }
    
                        #bss-b2b-discount-code-input-wrapper input#bss-b2b-discount-code-input {
                            min-height: 35px;
                            height: ${input_height}px;
                            width: ${input_width}px;
                            border: ${input_border_width}px ${input_border_color} ${input_border_style};
                            outline: none;
                            border-radius: ${input_border_radius}px;
                            color: #666;
                            padding: 0 15px;
                            background: transparent;
                        }
    
                        #bss-b2b-clear-discount-code {
                            height: 20px;
                            width: 20px;
                            right: 5px;
                            border-radius: 20px;
                            background: #a5a5a5;
                            color: white;
                            font-weight: bold;
                            text-align: center;
                            cursor: pointer;
                            line-height: 20px;
                            font-size: 11px;
                        }
    
                        #bss-b2b-clear-discount-code:hover {
                            background: #ccc;
                        }
    
                        #bss-b2b-discount-code-applied-wrapper {
                            display: flex;
                        }
    
                        div#bss-b2b-discount-code-applied {
                            border-radius: 4px;
                            background-color: rgba(113, 113, 113, 0.11);
                            color: #717171;
                            font-size: 15px;
                            padding: 5px;
                            overflow: hidden;
                            margin-left: 5px;
                            display: flex;
                            align-items: center;
                            gap: 15px;
                        }
    
                        #bss-b2b-discount-code-message {
                            margin-top: 5px;
                            margin-left: 5px;
                        }
    
                        @media only screen and (max-width: 600px) {
                            .bss-b2b-discount-code-wrapper {
                                width: 70%;
                                margin-left: 15%;
                                margin-top: 5%;
                            }
    
                        }
    
                        .bss-modal-warning-dc-wrap {
                            top: 21%;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            display: table;
                            z-index: 199999999;
                            position: fixed;
                            outline: none !important;
                            -webkit-backface-visibility: hidden;
                            pointer-events: none;
                        }
    
                        .bss-modal-dc {
                            opacity: .5;
                            color: black;
                            background-color: white;
                            max-width: 500px;
                            margin: 18px auto;
                            width: calc(100% - 36px);
                            pointer-events: auto;
                            border: solid white 1px;
                        }
    
                        .bss-modal-dc.activeDc {
                            opacity: 1;
                            transition: all 0.25s ease-in;
                            border-width: 0px;
                        }
    
                        .bss-modal-dc-header {
                            padding: 10px;
                            background: #ff9800;
                        }
    
                        .bss-modal-dc-title {
                            margin-left: 12px;
                            color: #000;
                            font-size: 20px;
                        }
    
                        .bss-modal-dc button {
                            user-select: none;
                            -webkit-user-select: none;
                            cursor: pointer;
                            float: right;
                            width: unset;
                        }
    
                        .bss-modal-dc-button-close {
                            font-style: normal;
                            margin-top: -5px;
                            margin-right: -5px;
                            font-size: 35px;
                            font-family: Arial, Baskerville, monospace;
                            overflow: visible;
                            background: transparent;
                            border: 0;
                            -webkit-appearance: none;
                            display: block;
                            outline: none;
                            padding: 0 0 0 10px;
                            box-shadow: none;
                            opacity: .65;
                        }
    
                        .bss-modal-dc-body {
                            padding: 18px;
                            background: #ffffff;
                            color: #000000;
                        }
    
                        .bss-dc-list-warning {
                            margin-left: 10px;
                            margin-top: -10px;
                        }
                    `;
    
                document.head.appendChild(style);
    
                const dcHTML = `
                        <div class="bss-b2b-discount-code-wrapper bss-config-header kc-dc-box">
                            <p class="bss-b2b-translation-dc-form_header_text">
                                ${form_header_text}
                            </p>
                            <div style="display: ${layout}; gap: 10px" > <div id="bss-b2b-discount-code-input-wrapper"> 
                                <input type="text" id="bss-b2b-discount-code-input" placeholder="${input_placeholder}" /> 
                                <div id="bss-b2b-discount-code-message">
                                    <span class="message dc-error" style="color: #FF0000"></span>
                                    <span class="message dc-success" style="color: #00FF00"></span>
                                </div> 
                                <div id="bss-b2b-discount-code-applied-wrapper" ></div>
                            </div>
                            <div>
                                <button id="bss-b2b-discount-code-submit" type="button" class="bss-b2b-translation-dc-button_apply" onClick="BSS_B2B.dc.utils.cart.handleSubmitCode()">
                                    <span>
                                        ${button_apply}
                                    </span>
                                </button>
                            </div> 
                        </div> 
                    </div>`;
    
                const selectorElementAnchorCartPage = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.discountCodes?.cartPage?.selector || '[name="checkout"]';
                const selectorElementAnchorCartSlider = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.discountCodes?.miniCart?.selector || '[name="checkout"]';
                let position = null;
                let elementAnchor = null;
    
                const interval = setInterval(() => {
                    if (window.KC.page.isCartPage()) {
                        elementAnchor = document.querySelector(selectorElementAnchorCartPage);
                        position = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.discountCodes?.cartPage?.position || 'beforeBegin';
                    } else {
                        elementAnchor = document.querySelector(selectorElementAnchorCartSlider);
                        position = window.KC.coreDataSelector[Shopify.theme.schema_name]?.anchor?.discountCodes?.miniCart?.position || 'beforeBegin';
                    }
    
                    if (elementAnchor && !elementAnchor.parentNode.querySelector(".bss-b2b-discount-code-wrapper.kc-dc-box")) {
                        document.querySelectorAll(".bss-b2b-discount-code-wrapper:not(.kc-dc-box)").forEach(item => { item.remove() });
                        if (document.querySelector(".kc-te-box")) {
                            elementAnchor = document.querySelector(".kc-te-box");
                            position = 'beforeBegin';
                        }
                        elementAnchor.insertAdjacentHTML(position, dcHTML);
                        BSS_B2B.dc.utils.cart.loadDcElements();
                        if (interval) {
                            clearInterval(interval);
                        }
                    }
                }, 100);
    
                setTimeout(() => {
                    if (interval) {
                        clearInterval(interval);
                    }
                }, 6000);
            } catch (e) {
                console.log(e)
            }
        }
    }
    
    window.KC.renderNT = function () {
        if(!BSS_B2B?.nt?.initFunction) return;
        try {
            const { selector = '[name="checkout"]', position = 'beforeBegin', checkoutSelector = '[name="checkout"]' } =
                window.KC.coreDataSelector?.[Shopify.theme.schema_name]?.anchor?.netterm?.[
                window.KC.page.isCartPage() ? 'cartPage' : 'miniCart'
                ] || {};
    
            const targetElement = document.querySelector(selector);
            if (!targetElement || (targetElement && targetElement.parentNode && targetElement.parentNode.querySelector("#bss-b2b-net-term-button-wrapper"))) return;
            targetElement.insertAdjacentHTML(position, `<div id="bss-b2b-net-term-button-wrapper">
                <button type="button" id="bss-b2b-net-term-button">Pay later</button>
            </div>`);
    
            BSS_B2B?.nt?.initFunction?.();
            document.dispatchEvent(new Event("DOMContentLoaded"))
            if (typeof window.KC.copyStyles === 'function') {
                const source = document.querySelector(checkoutSelector);
                const target = document.querySelector("#bss-b2b-net-term-button");
                if (source && target) {
                    window.KC.copyStyles(source, target);
                }
            }
        } catch (e) {
            console.log(e)
        }
    }
    
    const STYLE_ID = "disable-checkout-style";
    const selectorCheckout = `.boost-sd__btn-checkout:not(.bss-checkout), [name='checkout']:not(.bss-checkout), [href='/checkout']:not(.bss-checkout), .go-cart__button:not(.bss-checkout), .qsc2-checkout-button:not(.bss-checkout), .button-checkout:not(.bss-checkout)`;
    const selectorCheckoutBSS = `.bss-checkout`;
    
    function addDisableCheckoutStyle() {
        if (!document.getElementById(STYLE_ID)) {
            const style = document.createElement("style");
            style.id = STYLE_ID;
            style.textContent = `
                ${selectorCheckout}, ${selectorCheckoutBSS} {
                    pointer-events: none !important;
                    opacity: 0.6 !important;
                }
                `;
            document.head.appendChild(style);
        }
    }
    
    function removeDisableCheckoutStyle() {
        const style = document.getElementById(STYLE_ID);
        if (style) {
            style.remove();
        }
    }
    
    window.KC.cloneCheckout = function () {
        // document.addEventListener('click', function (event) {
        //     const clickedElement = event.target;
        //     const isInsideBSSCheckout = clickedElement.closest(selectorCheckoutBSS);
        //     if (isInsideBSSCheckout) {
        //         setTimeout(() => {
        //             const oldCheckout = window.findFirstMatchingElement(selectorCheckout);
        //             if (oldCheckout) {
        //                 oldCheckout.click();
        //             }
        //         }, 3000);
        //     }
        // });
    
        //addDisableCheckoutStyle()
    
        function cloneButtonWithStyles(originalButton) {
            const clone = originalButton.cloneNode(true);
            // const computedStyles = window.getComputedStyle(originalButton);
            // for (let i = 0; i < computedStyles.length; i++) {
            //     const propName = computedStyles[i];
            //     clone.style.setProperty(propName, computedStyles.getPropertyValue(propName));
            // }
            return clone;
        }
    
        let watchClassCheckout = false;
        function handleWatchClassCheckout(targets) {
            return;
            if (watchClassCheckout) return;
            watchClassCheckout = true;
            targets.forEach(target => {
                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            const allowedClass = 'bss-checkout';
                            const currentClasses = Array.from(target.classList);
                            if (currentClasses.length > 1 || !target.classList.contains(allowedClass)) {
                                target.className = allowedClass;
                            }
                        }
                    });
                });
                observer.observe(target, {
                    attributes: true,
                    attributeFilter: ['class'],
                    attributeOldValue: true
                });
            })
        }
    
        function fixCheckoutBtnSelector() {
            const defaultButtons = document.querySelectorAll(selectorCheckout);
            defaultButtons.forEach((btn) => {
                const container = btn.parentNode;
                if (container.querySelector(".bss-checkout")) return;
                const customCheckout = cloneButtonWithStyles(btn);
                customCheckout.removeAttribute("name");
                customCheckout.removeAttribute("form");
                customCheckout.removeAttribute("id");
                customCheckout.removeAttribute("href");
                customCheckout.removeAttribute("onclick");
                customCheckout.classList.add("bss-checkout");
                container.insertBefore(customCheckout, btn.nextSibling);
                Object.assign(btn.style, {
                    display: "none"
                });
                // Object.assign(customCheckout.style, {
                //     display: "inline-block",
                //     visibility: "visible",
                //     opacity: "1",
                //     pointerEvents: "unset"
                // });
            });
            //removeDisableCheckoutStyle();
            const cloneCheckout = document.querySelectorAll(selectorCheckoutBSS)
            handleWatchClassCheckout(cloneCheckout);
            document.dispatchEvent(new Event("KC:cloneCheckoutDone"))
            return cloneCheckout;
        }
    
        window.BSS_B2B.addFilter?.('custom:cart/checkout_ele', fixCheckoutBtnSelector);
    
        function handle_redirect_checkout() {
            // const checkoutBtn = document.querySelector(selectorCheckout);
            // console.log({checkoutBtn})
            // if (checkoutBtn) {
            //     checkoutBtn.click()
            // }
            window.location.href = '/checkout';
            return true;
        }
    
        window.BSS_B2B.addFilter?.('custom:redirect/checkout', handle_redirect_checkout);
    }
    
    const selector = window.KC.coreDataSelector[Shopify.theme.schema_name];
    if (selector) {
        let hasRun = false;
        function config_theme(config, { page }) {
            if (!hasRun) {
                // BSS_B2B.utils.SelectorsFactory.getSelectors('ProductListSelectors')._selectorData.Default.search_bar_wrap = ".bss-b2b-search-bar";
                BSS_B2B.utils.SelectorsFactory.getSelectors('ProductSelectors')._selectorData.Default.main_product_form = ".section-product-page .product__info-container .product__info-padded-main";
                hasRun = true;
            }
            return selector?.selector?.[page] || config;
        }
    
        window.BSS_B2B.addFilter('custom:config_theme/installation', config_theme);
    }
    
    window.KC.init = function () {
        try {
            window.KC.coreDataSelector?.[Shopify.theme.schema_name]?.coreJS?.();
        } catch (e) {
            console.log(e)
        }
        window.KC.renderTE();
        window.KC.renderDC();
        window.KC.renderNT();
    
    
    }
    
    window.KC.cloneCheckout();
    document.addEventListener('DOMContentLoaded', e => {
        window.KC.init();
    })
    
    document.addEventListener("bss_b2b:CustomCartUpdate", e => {
        try {
            addDisableCheckoutStyle();
            setTimeout(() => {
                window.KC.cloneCheckout();
                BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
            }, 1000);
            setTimeout(() => {
                removeDisableCheckoutStyle();
            }, 2500);
        } catch (e) {
            console.log(e)
        }
        window.KC.init();
        BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.()
    })
})();

// End automatically generated code by KC Solutions